{
  "LIST_FILTER_ROW": {
  	"aria_label": "filtros",
  	"status": "estado",
  	"open_amount": "saldo pendiente",
  	"more": "+{{count}} más",
  	"search_tag": "buscar etiqueta…",
  	"or_hint": "cualquiera de estas etiquetas",
  	"clear_all": "borrar todo",
  	"clear_filters": "borrar filtros",
  	"no_results_filters": "ninguna reserva con estos filtros.",
  	"clear_chip": "borrar {{name}}",
  	"bookings_total": "{{count}} reservas",
  	"bookings_total_one": "{{count}} reserva",
  	"flights_total": "{{count}} vuelos",
  	"flights_total_one": "{{count}} vuelo",
  	"search_hint": "Intro para buscar · fecha = aaaa-mm-dd",
  	"more_actions": "más acciones",
  	"period": "periodo",
  	"period_all": "todos",
  	"period_today": "hoy",
  	"period_this_week": "esta semana",
  	"period_this_month": "este mes",
  	"period_next_month": "el próximo mes",
  	"period_custom": "personalizado…",
  	"free_spots": "plazas libres",
  	"free_spots_all": "todas",
  	"free_spots_min": "al menos {{n}}",
  	"free_spots_overbooked": "sobrevendido"
  },
  "SEARCH_ELSEWHERE": {
    "none_in_filter": "sin resultados en «{{filter}}» para «{{search}}».",
    "found_in": "encontrado en:",
    "also_found_in": "también encontrado en"
  },
  "LOGIN": {
    "email_me_a_login_link": "envíame un enlace de acceso",
    "login_link_sent": "se ha enviado un enlace de acceso",
    "signed_in_elsewhere_title": "has iniciado sesión",
    "signed_in_elsewhere": "has iniciado sesión con el enlace en otra pestaña — puedes cerrar esta pestaña",
    "continue_here": "continuar aquí",
    "completing_signin": "iniciando sesión…",
    "confirm_email_for_link": "confirma tu dirección de correo para completar el inicio de sesión",
    "continue": "continuar",
    "login_link_invalid": "este enlace de acceso ya no es válido. solicita uno nuevo.",
    "request_new_link": "solicitar un enlace nuevo"
  },
  "MONTY": {
      "requested_prefix": "el cliente pide",
      "requested_MATCH": "{{date}} → vuelo {{flight}} ({{free}} libres)",
      "requested_CURRENT": "{{date}} → ya está en este vuelo ({{flight}})",
      "requested_FULL": "{{date}} → completo en la zona",
      "requested_NOT_PLANNED": "{{date}} → aún no hay vuelo previsto en la zona",
      "requested_PRIVATE_ONLY": "{{date}} → solo un vuelo privado ({{flight}})",
      "requested_OUT_OF_VALIDITY": "{{date}} → después de la validez de la reserva",
      "requested_PAST": "{{date}} → en el pasado",
      "date_conflict": "el día y la fecha no coincidían, se usó la fecha",
      "needs_review": "revise el texto: {{items}} no proviene de los datos del vuelo",
      "tag_P": "planificación",
      "tag_Q": "pregunta",
      "tag_W": "meteo",
      "tag_C": "queja / sensible",
      "tag_N": "sin acción necesaria",
      "action_accepted_line": "acción ejecutada vía Monty",
    "accept": "aceptar",
      "dismiss": "rechazar acción",
      "action_repick": "haz clic para elegir otro vuelo",
      "action_CONFIRM_ON_FLIGHT": "confirmar reserva en",
      "action_MOVE_TO_FLIGHT": "mover reserva a",
      "action_REMOVE_FROM_FLIGHT": "quitar reserva de",
      "failure_FLIGHT_FULL": "vuelo completo o cerrado — elige otro vuelo",
      "failure_FLIGHT_CANCELLED": "vuelo cancelado — elige otro vuelo",
      "failure_PROPOSAL_NOT_OPEN": "la propuesta ya no está abierta",
      "proposal_strip": "propuesta de Monty — ajusta o envía",
      "proposal_clear": "eliminar propuesta",
      "proposal_insert": "propuesta disponible — haz clic para insertar",
      "settings_panel_title": "Monty - tu asistente de IA",
      "settings_key_title": "clave API de Anthropic",
      "settings_key_note": "Monty funciona con tu propia cuenta de Anthropic: introduce tu clave API para activarlo. Los costes se facturan a tu cuenta.",
      "settings_key_label": "clave API",
      "settings_key_save": "guardar y validar",
      "settings_key_replace": "cambiar",
      "settings_key_remove": "eliminar",
      "status_active": "activo",
      "status_no_credits": "sin créditos — Monty está en pausa",
      "status_no_credits_note": "los mensajes nuevos no se etiquetan temporalmente; Monty se reanuda automáticamente cuando haya créditos",
      "status_key_invalid": "clave no válida — Monty está inactivo",
      "status_off": "sin configurar",
      "settings_usage_title": "consumo y costes",
      "settings_usage_note": "estimación basada en el consumo de tokens y los precios de lista; la facturación pasa por tu propia cuenta de Anthropic",
      "usage_month": "mes",
      "usage_classifications": "clasificaciones",
      "usage_proposals": "propuestas",
      "usage_cost": "coste estimado",
      "usage_learn_runs": "sesiones de aprendizaje",
      "instructions_title": "instrucciones por categoría",
      "instructions_note": "describe cómo sueles responder cada tipo de mensaje (tono, información estándar, normas) — Monty lo tiene en cuenta al redactar propuestas",
      "instructions_manual_label": "tus instrucciones",
      "instructions_learned_title": "propuesta del historial — revisa y ajusta",
      "instructions_learned_from": "basado en {{count}} mensajes respondidos de los últimos {{months}} meses",
      "instructions_learned_note": "Monty ya utiliza esta propuesta junto con tus propias instrucciones. Incorpórala a tus instrucciones para hacerla definitiva — de lo contrario, la próxima sesión de aprendizaje la reemplazará.",
      "instructions_adopt_draft": "incorporar a mis instrucciones",
      "instructions_discard_draft": "descartar propuesta",
      "instructions_save": "guardar",
      "learn_title": "aprender del historial",
      "learn_note": "Monty etiqueta tus conversaciones pasadas y destila por categoría cómo sueles responder; el resultado se añade arriba como propuesta editable",
      "learn_button": "aprender del historial",
      "learn_month": "mes",
      "learn_months": "meses",
      "learn_messages": "mensajes",
      "learn_estimated_cost": "coste estimado",
      "learn_warning": "esta sesión consume el crédito de tu propia cuenta de Anthropic",
      "learn_start": "iniciar aprendizaje",
      "learn_cancel_dialog": "cancelar",
      "learn_no_messages": "no hay mensajes en este período",
      "learn_progress": "{{done}} de {{total}} mensajes procesados",
      "learn_phase_TAGGING": "etiquetando el historial",
      "learn_phase_DISTILLING": "destilando instrucciones",
      "learn_state_RUNNING": "sesión de aprendizaje en curso",
      "learn_state_COMPLETED": "sesión de aprendizaje completada",
      "learn_state_CANCELLED": "sesión de aprendizaje cancelada",
      "learn_state_STOPPED_NO_CREDITS": "detenida — sin crédito; las etiquetas ya puestas se conservan",
      "learn_resume": "reanudar",
      "learn_cancel_run": "cancelar sesión",
      "learn_cost_so_far": "consumido"
  },
  "CHARTS": {
    "last1months": "1m",
    "last3months": "3m",
    "last6months": "6m",
    "last12months": "12m",
    "last24months": "24m"
  },
  "VALIDATIONS": {
    "checkin_edit": "editar",
    "checkin_clear_signoff": "borrar firma",
    "checkin_clear_signoff_confirm": "¿Borrar la firma del piloto? El vuelo contará como no firmado hasta que se firme de nuevo.",
    "checkin_manual_value": "establecido manualmente por el piloto durante el check-in",
    "checkin_signed_off": "el vuelo ya está firmado - borre primero la firma",
    "checkin_flight_not_found": "vuelo no encontrado",
    "checkin_invalid_hour": "hora de despegue no válida",
    "checkin_invalid_tempTakeoff": "la temperatura de despegue debe estar entre -40 y 50 °C",
    "checkin_invalid_tempBalloon": "la temperatura del globo debe estar entre 50 y 150 °C",
    "checkin_invalid_windGl": "el viento en superficie debe estar entre 0 y 60 kt",
    "checkin_invalid_windGlDirection": "la dirección del viento debe estar entre 0 y 360°",
    "checkin_invalid_weatherQnh": "el QNH debe estar entre 900 y 1100 hPa",
    "checkin_invalid_plannedFlightTime": "el tiempo de vuelo previsto debe ser positivo y no superar el tiempo máximo de vuelo",
    "load_failed": "no se han podido cargar estos datos",
    "error": "Ocurrió un error inesperado, revise su entrada",
    "minimun_one_adult_or_Child_is_required": "Necesita al menos un adulto o niño",
    "error_tenant_does_not_exist": "el operador no existe",
    "not_possible": "esta acción no es posible",
    "required": "campo requerido",
    "tenant_is_required": "operador es un campo requerido",
    "email_is_required": "el correo electrónico es un campo requerido",
    "wrong_password": "contraseña incorrecta",
    "check_email": "se envió un enlace para restablecer la contraseña",
    "International_phone_format": "formato internacional requerido",
    "email": "dirección de correo inválida",
    "duplicate_email": "no se permite duplicar direcciones de correo",
    "no_integer": "este no es un número entero válido",
    "positive_number": "debe ser cero o positivo",
    "lift_orange_below_red": "el límite verde debe ser al menos el límite naranja",
    "token_has_expired": "el token ha expirado",
    "wrong_credentials": "credenciales incorrectas",
    "flight_date_in_past": "este vuelo está en el pasado",
    "save_or_cancel_updates": "guarde o cancele sus cambios primero",
    "warning": "advertencia",
    "capacity_must_be_between_0_and_30": "la capacidad debe estar entre 0 y 100",
    "validation_errors": "corrija primero los errores en el formulario",
    "mismatch_location": "región no coincide",
    "mismatch_availability": "período no coincide",
    "mismatch_start_date": "fecha de vuelo demasiado pronto",
    "mismatch_end_date": "fecha de vuelo demasiado tarde",
    "mismatch_type": "tipo de vuelo no coincide",
    "mismatch_flight": "reservado para otro vuelo",
    "missing_function": "Esta función estará disponible pronto",
    "attachment_not_found": "archivo no encontrado en el almacenamiento",
    "invalid_file_only_pdf_jpg_png_max_10MB": "Archivo no válido: solo se aceptan PDF, JPG y PNG hasta 10 MB.",
    "invalid_file_too_large_max_10MB": "El archivo es demasiado grande: el tamaño máximo es 10 MB.",
    "no_category": "no se encontraron categorías de pasajeros, vaya primero a configuración para añadir 1 o más categorías.",
    "no_region": "no se encontró ninguna región, vaya primero a regiones para añadir 1 o más regiones.",
    "lift_mismatch": "el cálculo de sustentación no es posible debido a datos faltantes",
    "lift_missing_location": "falta la ubicación",
    "lift_missing_balloon_volume": "el volumen de la envoltura es desconocido",
    "lift_missing_balloon_weight": "el peso del globo es desconocido o incompleto",
    "lift_missing_pilot": "el piloto es desconocido",
    "lift_missing_pilot_weight": "el peso del piloto es desconocido",
    "lift_missing_temp_takeoff": "la temperatura de despegue es desconocida",
    "lift_missing_pressure": "la presión de despegue es desconocida",
    "mobile_missing_signature": "no todos los pasajeros han hecho check-in",
    "mobile_missing_forecast": "no hay pronóstico meteorológico disponible",
    "mobile_documents": "fechas de vencimiento",
    "mobile_doc_insurance": "seguro válido hasta",
    "mobile_doc_airworthiness": "aeronavegabilidad válida hasta",
    "mobile_doc_license": "licencia de piloto válida hasta",
    "mobile_clear": "borrar",
    "mobile_agree": "aceptar",
    "mobile_self_sign": "firmar X",
    "click_to_fly": "clic para volar",
    "click_to_fly_all": "confirmar todos",
    "pax_good_to_fly": "pasajeros ok",
    "lift_good_to_fly": "sustentación ok",
    "fuel_good_to_fly": "combustible ok",
    "weather_good_to_fly": "meteorología ok",
    "docs_good_to_fly": "documentos ok",
    "pilot_sign_off": "confirme todos los parámetros y firme para aprobar. Primero puede añadir comentarios sobre los parámetros.",
    "agree": "aceptar",
    "redo": "rehacer",
    "new_version": "nueva versión disponible",
    "reload_the_app": "¿desea reiniciar Quick Release ahora?",
    "new_features_available": "{0} nueva(s) función(es) disponible(s)",
    "show_new_features": "mostrar nuevas funciones",
    "forget_device": "cerrar sesión y olvidar dispositivo",
    "bookings_with_open_amount": "reservas con saldo pendiente",
    "bookings_to_confirm": "por confirmar",
    "bookings_bookmarked": "marcadores",
    "cylinder_capacity_must_be_between_0_and_200": "la capacidad debe estar entre 0 y 200",
    "cylinder_weight_must_be_between_0_and_200": "el peso debe estar entre 0 y 200",
    "unauthorized": "no está autorizado para esta operación",
    "disconnected": "problema de conectividad, ¿tiene internet?",
    "possible_duplicates": "hemos encontrado una posible reserva duplicada (se encontraron los mismos datos de contacto en otra reserva abierta)",
    "possible_duplicates_with_flights": "hemos encontrado una posible reserva duplicada en otro vuelo",
    "duplicate_flight": "el globo ya está programado",
    "duplicate_pilot": "el piloto ya está programado",
    "crew_ready_changed_warning": "La tripulación ya ha sido notificada. Por favor, infórmeles de los cambios."
  },
  "HINTS": {
    "add_country_code": "añada código de país +34...",
    "no_contact_selected": "Seleccione un contacto",
    "message_filter": "filtro on/off",
    "role_can_only_be_set_after_creation": "el rol solo puede establecerse después de la creación",
    "please_wait": "por favor espere"
  },
  "SKEYES": {
    "ballooning_bulletin": "Boletín de Aerostación",
    "load": "Iniciar sesión en Skeyes",
    "disclaimer": "El boletín de aerostación es un servicio de Skeyes",
    "instructions": "Introduzca su usuario y contraseña de Skeyes para consultar el Boletín de Aerostación. Solo los pilotos con licencia válida pueden consultar el Boletín de Aerostación. Los datos solo se utilizan para consultar el Boletín de Aerostación y no se almacenan. Se aplican los términos de uso de Skeyes.",
    "username": "Usuario de Skeyes",
    "password": "Contraseña de Skeyes",
    "loaded_by": "cargado por",
    "loading_can_take_up_to_15sec": "la carga puede tardar hasta 15 segundos",
    "error": "error al cargar el boletín de aerostación",
    "slot_warning": "este boletín probablemente no es válido para este vuelo"
  },
  "APPLICATION": {
    "domain": "dominio",
    "Du": "nederlands (Nederland)",
    "Nl": "nederlands (België)",
    "Fr": "français (french)",
    "En": "english",
    "Es": "español (spanish)",
    "Cs": "cesky (czech)",
    "It": "Italiano (Italian)",
    "De": "Deutsch (German)",
    "Pt": "Português (portuguese)",
    "Lv": "Latviešu (Latvian)",
    "date": "fecha",
    "name": "nombre",
    "call_sign": "indicativo",
    "capacity": "capacidad",
    "flight_count": "vuelos",
    "sku": "sku",
    "unit_count": "unidades",
    "unit_cost": "precio unitario",
    "send_sms": "enviar sms",
    "receive_sms": "sms recibidos",
    "sms_count": "sms",
    "payments": "pagos",
    "running_month": "mes actual",
    "history_balloons": "historial de globos",
    "history_sms": "historial de sms",
    "total_cost": "precio",
    "sorry": "lo sentimos",
    "flights": "vuelos",
    "calendar": "calendario",
    "vouchers": "bonos",
    "bookings": "reservas",
    "balloons": "globos",
    "crew": "tripulación y pilotos",
    "regions": "regiones",
    "locations": "ubicaciones",
    "reports": "informes",
    "logbooks": "cuadernos de bitácora",
    "admin": "admin",
    "releasenotes": "notas de versión",
    "subscription": "suscripción",
    "log_sms_in": "sms entrantes",
    "log_sms_out": "sms salientes",
    "settings": "configuración",
    "cylinders": "cilindros",
    "language": "idioma",
    "sms": "sms",
    "help": "ayuda",
    "search": "buscar",
    "live_filter_off": "Use el botón de búsqueda para buscar. Si desea más de 25 resultados, la búsqueda en vivo está desactivada",
    "add_booking": "añadir reserva",
    "add_voucher": "añadir bono",
    "add_flight": "añadir vuelo",
    "privacy_policy": "política de privacidad",
    "terms": "términos",
    "sign in to use your Quick Release Account": "inicie sesión para usar su cuenta de Quick Release",
    "your username and password didn't match": "su usuario y contraseña no coinciden",
    "please try again": "por favor intente de nuevo",
    "username": "usuario",
    "password": "contraseña",
    "sign_in": "iniciar sesión",
    "send_PIN": "enviar PIN",
    "use_PIN": "usar PIN",
    "pin_successfully_sent": "PIN enviado correctamente",
    "use_password": "usar contraseña",
    "send_email": "enviar correo",
    "email": "correo electrónico",
    "send_email_to": "seleccionar destinatario",
    "select_template": "seleccionar plantilla",
    "sent": "enviado",
    "waiting": "enviando",
    "error": "envío fallido",
    "pin": "PIN",
    "verification_code": "código de verificación",
    "verification_code_subtitle": "Introduzca el código de 6 dígitos que recibió por correo electrónico",
    "resend_code": "reenviar código",
    "resend_code_disabled": "reenviar código en 30 segundos",
    "code_required": "El código es requerido",
    "code_pattern": "Debe tener 6 dígitos",
    "verify_code": "verificar código",
    "trust_device": "Este dispositivo será de confianza durante 60 días. En los próximos 60 días, no necesitará un código de verificación para iniciar sesión",
    "sign_out": "cerrar sesión",
    "save": "guardar",
    "save_and_back": "guardar y volver",
    "cancel": "cancelar",
    "previous": "anterior",
    "delete": "eliminar",
    "refresh": "actualizar",
    "new_version_available": "hay una nueva versión de Quick Release disponible",
    "today": "hoy",
    "classic": "volver a la interfaz antigua",
    "month": "mes",
    "week": "semana",
    "morning_flights": "vuelos matutinos hoy",
    "evening_flights": "vuelos vespertinos hoy",
    "morning_flights_tomorrow": "vuelos matutinos mañana",
    "yesterday_flights": "vuelos vespertinos ayer",
    "action": "acción",
    "version": "versión",
    "messages": "mensajes",
    "assign": "asignar",
    "assigned": "asignado",
    "assign_to": "asignar vuelo a",
    "close": "cerrar",
    "apps": "recursos",
    "more": "más"
  },
  "CALENDAR": {
    "MATRIX": {
      "plan_flight": "planificar un vuelo",
      "flyability_flight_location": "aviso de flyability para el sitio de este vuelo",
      "pilot": "piloto",
      "driver_be": "conductor (BE)",
      "crew": "equipo",
      "occupancy": "ocupación confirmada / añadida",
      "cancelled": "cancelado",
      "conflict_tooltip": "varios vuelos en la misma franja — haz clic para resolver en el planificador diario",
      "morning": "mañana",
      "evening": "tarde",
      "weather_anchor": "tiempo & sol: sitio por defecto",
      "weather_anchor_tooltip": "el tiempo diario y las horas de sol corresponden al sitio por defecto; las celdas de vuelo muestran la flyability de su propio sitio",
      "no_default_location": "define un sitio por defecto para ver el tiempo diario y las horas de sol",
      "sunrise_tooltip": "amanecer en el sitio por defecto",
      "sunset_tooltip": "atardecer en el sitio por defecto",
      "open_bookings": "reservas abiertas",
      "load_more": "cargar más",
      "already_assigned_tooltip": "ya asignada a este vuelo — soltarla en otro sitio la mueve, nunca la duplica",
      "open": "abiertas",
      "events": "eventos",
      "seats": "plazas",
      "move_overflow_title": "capacidad insuficiente",
      "move_overflow_body": "El globo destino tiene menos plazas que pasajeros en este vuelo. ¿Mover de todos modos?",
      "flights": "vuelos",
      "available": "disponible",
      "no_availability_info": "sin información de disponibilidad para esta franja",
      "edit_hint": "haz clic en un campo de una tarjeta para editarlo en un pop-up — edición completa en el detalle del vuelo",
      "location": "sitio",
      "pilot_crew": "piloto & equipo",
      "weather": "tiempo",
      "lift": "lift",
      "comment": "comentario",
      "edit_in_popup": "editar en pop-up",
      "assign": "— asignar",
      "move": "mover",
      "flight_detail": "detalle del vuelo",
      "drop_bookings_here": "aún sin reservas — arrástralas aquí",
      "search_placeholder": "buscar por nombre, teléfono o comentario…",
      "search_hint": "Enter — busca en el servidor",
      "no_open_bookings": "sin reservas abiertas para esta franja",
      "waiting_list_hint": "arrastra una reserva asignada aquí para desasignarla",
      "back_to_classic": "volver al panel clásico",
      "previous_week": "semana anterior",
      "next_week": "semana siguiente",
      "this_week": "esta semana",
      "classic_until": "disponible hasta el 31 de marzo de 2027",
      "try_matrix_banner": "Prueba el nuevo panel con planificación semanal — será el estándar el 31 de marzo de 2027.",
      "try_matrix": "probar",
      "create": "crear",
      "hour_derived": "automático: amanecer/atardecer en el sitio elegido, incl. tu offset",
      "hour": "hora",
      "date": "fecha",
      "period": "franja",
      "balloon": "globo"
    },
    "waiting_list": "lista de espera",
    "no_bookings_yet": "aún no hay reservas",
    "drag_and_drop_reservations_here_to_add_to_this_flight": "arrastre y suelte las reservas aquí para añadirlas a este vuelo",
    "drag_and_drop_reservations_here_to_remove_from_this_flight": "arrastre y suelte las reservas aquí para quitarlas del vuelo",
    "good_job": "¡buen trabajo!",
    "all_bookings_are_added_to_a_flight": "todas las reservas fueron añadidas a un vuelo",
    "you_cannot_drop_bookings_here": "no puede soltar reservas aquí",
    "show_calendar_crew": "mostrar calendario de tripulación",
    "set_month": "establecer mes",
    "clear_month": "eliminar todo",
    "plan": "planificar",
    "refetch": "actualizar",
    "show_all_pilots": "mostrar todos los pilotos",
    "show_all_crew": "mostrar toda la tripulación"
  },
  "ACTORS": {
    "COM": "CPL",
    "NCO": "PPL",
    "NOL": "sin licencia",
    "NOA": "sin acceso",
    "OPR": "operador",
    "CRE": "piloto/tripulación (solo vuelos asignados)",
    "REP": "visor de informes",
    "ASS": "Asistente de operador (vuelos y reservas)",
    "MET": "meteo (solo vuelos)",
    "user_role": "rol de usuario",
    "name": "nombre",
    "phone": "teléfono",
    "email": "correo electrónico",
    "used_for_login": "usado para inicio de sesión",
    "emailNotifications": "notificaciones por correo",
    "emails_from_the_system_will_be_send_to_this_address": "los correos del sistema se enviarán a esta dirección, no a la dirección de inicio de sesión",
    "driver_license": "permiso de conducir",
    "driver_license_none": "sin permiso",
    "pilot_license": "licencia de piloto",
    "ground_crew": "tripulación de tierra",
    "language": "idioma",
    "confirm_message": "¿está seguro de que desea eliminar?",
    "confirm": "confirmar",
    "contacts": "contactos",
    "update": "actualizar",
    "delete": "eliminar",
    "save": "guardar",
    "add_contact": "añadir contacto",
    "crew": "tripulación",
    "pilot": "piloto",
    "add_crew": "añadir tripulación",
    "national_license": "licencia nacional",
    "part_fcl_license": "licencia PART-FCL",
    "license_group_A": "grupo A",
    "license_group_B": "grupo B",
    "license_group_C": "grupo C",
    "license_group_D": "grupo D",
    "license_gas": "globo de gas",
    "license_number": "número de licencia",
    "license_expiry_date": "fecha de vencimiento de licencia / OPC",
    "license_extra_crew": "licencia tripulación extra",
    "ground_crew_training_expiry_date": "fecha de vencimiento de formación de tripulación de tierra",
    "first_aid_expiry_date": "fecha de vencimiento de formación en primeros auxilios",
    "fire_extinguisher_expiry_date": "fecha de vencimiento de formación en extinción de incendios",
    "medical_expiry_date": "fecha de vencimiento del certificado médico",
    "weight": "peso",
    "warning_not_current": "la validez del piloto expira en 30 días, verifique las fechas de vencimiento",
    "error_not_current": "piloto inhabilitado, verifique las fechas de vencimiento",
    "assigned_to_flight": "asignado al vuelo",
    "your_flight": "su vuelo",
    "your_flights": "sus vuelos",
    "pilots": "pilotos",
    "drivers": "equipo de apoyo"
  },
  "BALLOONS": {
    "upload_photo": "subir foto",
    "name": "nombre",
    "call_sign": "indicativo",
    "capacity": "plazas",
    "total_weight": "peso total",
    "balloons": "globos",
    "confirm_message": "¿está seguro de que desea eliminar?",
    "confirm": "confirmar",
    "update": "actualizar",
    "delete": "eliminar",
    "save": "guardar",
    "add_balloon": "añadir globo",
    "group": "grupo",
    "MLM": "MTM (Masa Mínima de Aterrizaje)",
    "MTOM": "MTOM (Masa Máxima al Despegue)",
    "lift_warning_title": "zonas de aviso de sustentación",
    "lift_warning_explain": "color de la sustentación de reserva por vuelo: dudoso (naranja) a partir del primer valor, bueno (verde) a partir del segundo — por debajo del límite naranja el vuelo pasa a rojo. El azul aparece si el vuelo podría aterrizar por debajo de la MLM.",
    "lift_warning_unconfigured": "sin configurar — solo una reserva negativa se muestra en rojo",
    "lift_zone_red": "demasiado baja",
    "lift_zone_orange": "dudoso",
    "lift_zone_green": "bueno",
    "lift_orange_from": "dudoso (naranja) a partir de",
    "lift_good_from": "bueno (verde) a partir de",
    "min_fuel": "consumo promedio (litros por hora)",
    "liter_per_hour": "litros por hora",
    "fuel": "consumo a 20°C y número máximo de pasajeros",
    "envelope": "envoltura",
    "envelope_manufacturer": "fabricante de envoltura",
    "envelope_type": "tipo de envoltura",
    "envelope_volume": "volumen de envoltura",
    "envelope_weight": "peso de envoltura",
    "envelope_hours": "horas de envoltura",
    "envelope_inspection_date": "inspección válida hasta",
    "balloon_temp": "temperatura de envoltura",
    "burner": "quemador",
    "burner_manufacturer": "fabricante de quemador",
    "burner_type": "tipo de quemador",
    "burner_weight": "peso de quemador",
    "cylinder_hint": "Guarde primero el globo y luego añada los cilindros. Asegúrese de crear primero los cilindros en el sistema. Los mismos cilindros pueden usarse en múltiples globos",
    "cylinder": "cilindros",
    "cylinder_manufacturer": "fabricante",
    "cylinder_volume": "volumen",
    "cylinder_count": "cantidad",
    "cylinder_empty_weight": "peso vacío",
    "cylinder_full_weight": "peso lleno",
    "cylinder_total_weight": "peso total",
    "cylinder_number": "número",
    "cylinder_serial": "número de serie",
    "basket": "cesta",
    "basket_manufacturer": "fabricante de cesta",
    "basket_type": "tipo de cesta",
    "basket_weight": "peso de cesta",
    "insurance_company": "compañía de seguros",
    "insurance_due_date": "fecha de vencimiento del seguro",
    "add_cylinder": "añadir cilindro",
    "error_not_current": "Globo inhabilitado, actualice las fechas de vencimiento",
    "warning_not_current": "El globo vence en 30 días, actualice las fechas de vencimiento"
  },
  "VOUCHERS": {
    "status": "estado",
    "create_booking": "crear reserva",
    "available": "disponible",
    "used": "usado",
    "expired": "expirado",
    "voucher_type": "tipo",
    "show_all_types": "mostrar todos los tipos",
    "voucher_reference": "referencia",
    "issue_date": "fecha de emisión",
    "expiry_date": "fecha de vencimiento",
    "contactName": "nombre de contacto",
    "contactPhone": "teléfono",
    "contactLanguage": "idioma",
    "contactEmail": "correo electrónico",
    "contact_city": "ciudad",
    "recipient_info": "datos de la persona que recibirá y usará el bono",
    "buyer_info": "datos de la persona que compró el bono",
    "details_info": "información específica sobre el bono",
    "buyer": "comprado por",
    "recipient": "destinatario",
    "recipientName": "nombre",
    "recipientPhone": "teléfono",
    "recipientLanguage": "idioma",
    "recipientEmail": "correo electrónico",
    "recipientAddress": "dirección",
    "recipientPostalCode": "código postal",
    "recipientCity": "ciudad",
    "recipientCountry": "país",
    "details": "detalles",
    "comments": "comentarios",
    "paymentAmount": "importe",
    "paymentStatus": "estado del pago",
    "paymentDate": "fecha de pago",
    "adults": "adultos",
    "children": "niños",
    "external": "externo",
    "external_source": "origen",
    "tickets": "entradas",
    "voucher": "bono",
    "available_vouchers": "bonos disponibles",
    "confirm_message": "¿está seguro de que desea eliminar este bono?",
    "unpaid_vouchers": "¡Advertencia! bonos sin pagar",
    "IMPORT": {
      "import": "importar",
      "upload_csv": "subir CSV",
      "upload_valid_csv_with_this_header": "suba un CSV válido con la siguiente cabecera",
      "example_with_2_adults": "ejemplo de un bono con 2 adultos",
      "choose_file": "elegir archivo",
      "check_file": "verificar archivo",
      "check_errors": "verificar errores",
      "not_a_valid_CSV": "este no es un CSV válido",
      "valid_CSV": "sin errores de validación",
      "click_import": "clic en importar",
      "number_of_vouchers": "número de bonos",
      "import_status": "estado de importación",
      "imported_succesfully": "importado correctamente",
      "imported_with_errors": "errores durante la importación",
      "finish": "finalizar",
      "row": "fila",
      "error_more_less_columns": "más o menos columnas de las esperadas",
      "error_header": "error en la cabecera",
      "error_contact_name": "error en contactName, este campo es obligatorio",
      "error_contact_phone": "error en contactPhone, este campo es obligatorio y en formato M:+34...",
      "error_contact_language": "error en contactLanguage, este campo es obligatorio",
      "error_voucher_type": "error en tipo de bono, este campo es obligatorio",
      "error_voucher_reference": "error en referencia del bono, este campo es obligatorio",
      "error_issue_date": "error en fecha de emisión, este campo es obligatorio y en formato AAAA-MM-DD",
      "error_expiry_date": "error en fecha de vencimiento, este campo es obligatorio y en formato AAAA-MM-DD",
      "error_payment_date": "error en fecha de pago, este campo es obligatorio y en formato AAAA-MM-DD",
      "error_payment_status": "error en estado de pago, este campo es obligatorio y los valores aceptados son OPEN o PAID",
      "error_payment_type": "error en tipo de pago, este campo es obligatorio y los valores aceptados son NOPA, CASH, WIRE, BANC, CRED, ONLI",
      "error_adults": "error en adultos, debe ser un número",
      "error_children": "error en niños, debe ser un número",
      "error_import": "error durante la importación",
      "succes_import": "importado correctamente",
      "cancel": "cancelar"
    }
  },
  "BOOKINGS": {
  	"email_export_tooltip_open_amount": "con saldo pendiente",
    "email_passengers": "enviar correo a pasajeros",
    "email_export_tooltip": "exportar direcciones de correo de los pasajeros a CSV",
    "email_export_tooltip_dynamic": "Descargar todas las direcciones de correo de los pasajeros ({{filter}}){{extras}}",
    "email_export_tooltip_tags": "con la etiqueta {{tags}}",
    "email_export_tooltip_search": "que coinciden con '{{search}}'",
    "email_export_success": "{{count}} direcciones de correo exportadas",
    "email_export_empty": "no hay direcciones de correo para exportar",
    "id": "id",
    "availability": "disponibilidad",
    "PERI": "disponibilidad en cualquier fecha",
    "DATE": "disponibilidad en una fecha específica",
    "MOR": "mañana",
    "EVE": "tarde",
    "mo": "lu",
    "tu": "ma",
    "we": "mi",
    "th": "ju",
    "fr": "vi",
    "sa": "sa",
    "su": "do",
    "save": "guardar",
    "child": "niño",
    "name": "nombre",
    "weight": "peso",
    "luggage": "equipaje",
    "paymentType": "tipo de pago",
    "paymentReference": "referencia de pago",
    "paymentAmount": "importe del pago",
    "paymentStatus": "estado del pago",
    "paymentDate": "fecha de pago",
    "delete": "eliminar",
    "OPEN": "abierta",
    "UNK": "añadido",
    "INV": "invitado",
    "CON": "confirmado",
    "completed": "completado",
    "CAN": "cancelado",
    "CPP": "pasajeros comerciales privados",
    "COP": "pasajeros comerciales",
    "NCP": "pasajeros no comerciales",
    "booking_date": "fecha de reserva",
    "days_expired": "{{ d }} días vencidos",
    "startDate": "fecha de inicio",
    "endDate": "fecha de fin",
    "status": "estado",
    "bookingType": "tipo de reserva",
    "bookingCode": "referencia de reserva",
    "bookingCodeHint": "clic para abrir la aplicación de pasajeros",
    "bookingCodeMissingEmail": "sin correo electrónico, los pasajeros no tienen acceso a la reserva en la aplicación de pasajeros",
    "commentsTitle": "comentarios",
    "comments": "comentarios internos",
    "pax_comments": "comentarios del pasajero",
    "region": "región",
    "source": "origen",
    "new_source": "nuevo origen",
    "you_can_manage_all_sources_in_settings": "puede gestionar todos los orígenes en configuración",
    "source_validation": "el origen es obligatorio, mín 3, máx 50 caracteres y debe ser único",
    "source_list_validation": "elija un origen de la lista o cree primero uno nuevo",
    "source_list_empty": "no se encontraron orígenes, clic en nuevo origen",
    "locationType": "ubicación",
    "REGI": "todas las ubicaciones en una región",
    "FIXE": "ubicación específica en una región",
    "PRIV": "ubicación privada",
    "contactPerson": "persona de contacto",
    "logsRemoved": "número de veces eliminado de un vuelo",
    "contactName": "nombre de contacto",
    "contactPhone": "teléfono de contacto",
    "contactEmail": "correo de contacto",
    "contactLanguage": "idioma de contacto",
    "action_needed": "acción requerida",
    "answer_flight_yes_no": "responda VUELO SÍ o VUELO NO",
    "flight_yes": "VUELO SÍ",
    "flight_no": "VUELO NO",
    "PAID": "pagado",
    "REFUNDED": "reembolsado",
    "not_paid": "por pagar",
    "CASH": "efectivo",
    "COUP": "bono (en sistema)",
    "VOUC": "bono",
    "NOPA": "sin pago",
    "CHEQ": "cheque",
    "WIRE": "transferencia bancaria",
    "BANC": "bancontact",
    "CRED": "tarjeta de crédito",
    "ONLI": "online",
    "INVO": "factura",
    "only_available_with_paymenttype_voucher": "solo disponible con tipo de pago bono",
    "bookings": "reservas",
    "booking": "reserva",
    "confirm": "confirmar",
    "update": "actualizar",
    "contact": "contacto",
    "passengers": "pasajeros",
    "cancel": "cancelar",
    "next": "siguiente",
    "flightDate": "fecha del vuelo",
    "flightPeriod": "período del vuelo",
    "flight_balloon": "globo del vuelo",
    "flight_location": "ubicación del vuelo",
    "flight_pilot": "piloto del vuelo",
    "add_passenger": "añadir pasajero",
    "messages": "mensajes",
    "no_bookings_found": "no se encontraron reservas",
    "inviteCount": "invitaciones",
    "confirm_message": "¿está seguro de que desea eliminar esta reserva?",
    "delete_blocked_on_flight": "Quita esta reserva del vuelo antes de poder eliminarla.",
    "always_available": "siempre disponible",
    "limited_availability": "disponibilidad limitada",
    "end_before": "vuelo antes de",
    "passenger": "pasajero",
    "details": "detalles",
    "payment_details": "pagos",
    "address_details": "información de dirección",
    "disability": "asistencia requerida",
    "category": "categoría",
    "address": "dirección",
    "postalCode": "código postal",
    "city": "ciudad",
    "country": "país",
    "signature": "firma",
    "added_flight": "vuelo seleccionado",
    "select_flight": "seleccionar vuelo",
    "no_flight_added": "ningún vuelo seleccionado",
    "no_flight_data": "los datos del vuelo solo se muestran si la ubicación y fecha están fijadas",
    "available_flights": "vuelos disponibles",
    "no_available_flights": "no hay vuelos disponibles",
    "available_balloons": "globos disponibles",
    "no_available_balloons": "no hay globos disponibles",
    "totalAmount": "importe total",
    "paid_amount": "pagado",
    "openAmount": "saldo pendiente",
    "prepayment": "anticipo",
    "prepaymentDate": "fecha de anticipo",
    "passengers_to_pay": "pasajero(s) por pagar",
    "default_weight_warning": "Peso por defecto - necesita confirmación",
    "passengers_with_default_weight": "{{ count }} pasajero(s) con peso por defecto",
    "confirm_weight": "Confirmar peso",
    "mark_paid": "marcar como pagado",
    "remove_from_passengerlist": "eliminar de la lista de pasajeros",
    "add_to_passengerlist": "añadir pasajero adicional",
    "checkin_passengers": "volver al check-in",
    "view_checked_in": "mostrar pasajeros con check-in",
    "hide_checked_in": "ocultar pasajeros con check-in",
    "check_in_all": "check-in de todos los pasajeros",
    "import": "importar",
    "upload_csv": "subir CSV",
    "upload_valid_csv_with_this_header": "suba un archivo CSV válido con la siguiente cabecera",
    "example_in_region_with_id_1_with_2_adults_and_0_children": "ejemplo de una reserva con 2 adultos en la región con Id 1",
    "choose_file": "seleccionar archivo",
    "check_file": "verificar archivo",
    "check_errors": "corrija los siguientes errores",
    "not_a_valid_CSV": "este no es un archivo válido",
    "valid_CSV": "no hay errores",
    "click_import": "clic para importar",
    "number_of_bookings": "número de reservas",
    "number_of_objects_upcoming": "próximas",
    "number_of_objects_history": "históricas",
    "import_status": "estado de importación",
    "imported_succesfully": "importado correctamente",
    "imported_with_errors": "errores durante la importación",
    "finish": "finalizar",
    "row": "fila",
    "error_more_less_columns": "más o menos columnas de las esperadas",
    "error_header": "error en la cabecera",
    "error_contact_name": "error en contactName, este campo es obligatorio",
    "error_contact_phone": "error en contactPhone, este campo es obligatorio y en formato M:+34...",
    "error_contact_language": "error en contactLanguage, este campo es obligatorio",
    "error_region": "error en región, este campo es obligatorio y debe tener el ID de la región",
    "error_adults": "error en adultos, debe ser un número",
    "error_children": "error en niños, debe ser un número",
    "errorImport": "error durante la importación",
    "succesImport": "importado correctamente",
    "flight_confirmation": "confirmación de vuelo",
    "date_filter_is_yyyy-mm-dd": "filtro de fecha = aaaa-mm-dd",
    "FILTER": {
    	"standard": "todas las activas",
    	"standard_desc": "todo lo que aún debe volar",
    	"toPlan": "por planificar",
    	"toPlan_desc": "aún sin vuelo",
    	"toConfirm": "por confirmar",
    	"toConfirm_desc": "solicitada por el pasajero",
    	"invited": "invitadas",
    	"invited_desc": "esperando respuesta del pasajero",
    	"confirmed": "confirmadas",
    	"confirmed_desc": "fijada en un vuelo",
    	"expired": "caducadas",
    	"expired_desc": "validez vencida, aún sin volar",
    	"history": "cerradas",
    	"history_desc": "voladas o canceladas"
    },
    "import_bookings": "importar reservas (CSV)",
    "expired_on_flight_date": "ya no es válida en la fecha del vuelo",
    "flight_confirmed": "vuelo confirmado",
    "invited_waiting_answer": "invitado, esperando respuesta",
    "MERGE": {
      "merge": "fusionar",
      "load": "cargar",
      "restart": "reiniciar",
      "select_booking": "seleccionar reservas",
      "select_booking_hint": "la reserva del lado izquierdo se eliminará, la del lado derecho se guardará",
      "merge_booking": "fusionar reservas",
      "merge_booking_hint": "dé su consentimiento antes de poder guardar y eliminar",
      "booking_id_to_delete": "id de reserva a eliminar",
      "booking_id_to_merge": "id de reserva a fusionar",
      "error_loading": "error durante la carga, seleccione otro id o reinicie",
      "warning_to_switch": "advertencia: eligió eliminar la reserva más reciente",
      "save_and_delete": "guardar esta reserva y eliminar",
      "confirm_to_delete": "consentimiento para eliminar",
      "replace": "reemplazar",
      "add": "añadir",
      "undo": "deshacer",
      "fields_are_identical": "los campos son idénticos",
      "remove": "eliminar"
    },
    "LOG": {
      "logbook": "cuaderno de bitácora",
      "outbox": "correos enviados",
      "only_logs_from_UI": "registros de Quick Release (no de UP ni del sitio web)",
      "ADDE": "añadido al vuelo",
      "REMO": "eliminado del vuelo",
      "CONF": "confirmado para el vuelo",
      "cancel": "vuelo cancelado, movido a lista de reservas",
      "COMP": "vuelo ejecutado, movido a historial (completado)",
      "INVI": "invitado por MSG al vuelo",
      "CREA": "reserva creada en el sistema",
      "update": "reserva actualizada en uno o más campos",
      "DELE": "reserva eliminada del sistema",
      "MAIL": "correo enviado",
      "TRANSFER": "transferido a otra cesta",
      "view_email": "mostrar correo",
      "flight": "vuelo"
    },
    "vat_number": "número de IVA",
    "invoice_name": "nombre en factura",
    "age": "edad",
    "transport": "transporte",
    "age_amount": "años"
  },
  "COMMUNICATIONS": {
    "RETENTION": {
      "title": "conservación de mensajes",
      "explanation": "Elija cuánto tiempo se conservan los mensajes. Los mensajes más antiguos desaparecen inmediatamente del panel y se eliminan definitivamente después de 90 días — durante esos 90 días puede recuperarlas restableciendo la configuración. Los mensajes de reservas abiertas se conservan siempre. Como responsable del tratamiento, usted elige y justifica el plazo de conservación.",
      "closedBookings": "reservas cerradas",
      "crew": "tripulación",
      "never": "nunca (conservar siempre)",
      "years": "años",
      "year": "año",
      "recommended": "recomendado: 2 años",
      "recommendedShort": "recomendado",
      "confirmTitle": "¿eliminar mensajes antiguos?",
      "confirmBody": "{{total}} mensajes ({{closedBookingMessages}} de reservas cerradas, {{crewMessages}} de tripulación) desaparecerán ahora y se eliminarán definitivamente después de 90 días. Durante esos 90 días puede recuperarlos restableciendo la configuración; después se perderán para siempre.",
      "policyClosedYears": "Los mensajes de reservas cerradas se eliminan cuando el mensaje en sí tiene más de {{years}} año(s).",
      "policyClosedNever": "Los mensajes de reservas cerradas se conservan para siempre. Atención: esto bloquea establecer una nueva conexión de WhatsApp.",
      "policyCrewYears": "Los mensajes de tripulación se eliminan cuando el mensaje en sí tiene más de {{years}} año(s).",
      "policyCrewNever": "Los mensajes de tripulación se conservan para siempre.",
      "pendingDeletion": "{{count}} mensajes están programados para eliminación — en {{days}} días se eliminarán definitivamente.",
      "connectBlocked": "Para conectar WhatsApp primero debe establecer un plazo de conservación de mensajes para las reservas cerradas (véase «conservación de mensajes» más abajo)."
    },
    "sent_at": "enviado a las",
    "phone": "teléfono",
    "name": "nombre",
    "text": "texto",
    "status": "estado",
    "message_id": "id de mensaje",
    "message_price": "precio del mensaje",
    "network": "red",
    "remaining_balance": "saldo restante",
    "received_at": "recibido a las",
    "msisdn": "msisdn",
    "message_timestamp": "marca de tiempo del mensaje",
    "keyword": "palabra clave",
    "pilot_invitation_sms": "MSG a pilotos",
    "crew_invitation_sms": "MSG a tripulación",
    "checkin_notification_sms": "check-in invitation",
    "booking_confirmation_sms": "booking confirmation",
    "passenger_invitation_sms": "MSG a pasajeros",
    "cancel_sms": "MSG para cancelar",
    "reminder_sms": "MSG de recordatorio",
    "reminder_wa": "WhatsApp de recordatorio",
    "sms_in": "sms entrantes",
    "messages": "mensajes",
    "flight": "vuelo",
    "booking": "reserva",
    "crew": "crew",
    "sms_out": "sms salientes",
    "to": "para",
    "unanswered_messages": "mensajes sin respuesta",
    "mark_all_as_read": "marcar todos los {0} mensajes como leídos",
    "mark": "marcar",
    "mark_all": "marcar todos",
    "mark_paid": "marcar pagado",
    "mark_not_paid": "marcar no pagado",
    "messages_as_read": "mensajes como leídos",
    "you": "usted",
    "mail_copy": "PDF por correo",
    "action_succeed": "acción exitosa",
    "accepted": "aceptado",
    "delivered": "entregado",
    "sent": "enviado",
    "failed": "error en la entrega",
    "unknown": "error desconocido",
    "retry": "reintentar más tarde",
    "wrongnumber": "número incorrecto",
    "none": "ninguno",
    "fallback_hint": "WhatsApp sin conexión — créditos SMS disponibles. Active el SMS de respaldo en ajustes.",
    "WHATSAPP": {
      "CHANNEL": {
          "chooser": "canal de WhatsApp",
          "free": "WhatsApp gratis",
          "freeHint": "dispositivo vinculado — gratuito, pero no oficial; Meta puede bloquearlo",
          "business": "WhatsApp Business",
          "businessHint": "canal oficial de Meta a través de tu propia cuenta de Meta — sin bloqueos, de pago por mensaje",
          "active": "activo",
          "settingUp": "en configuración",
          "freeInactiveExplain": "WhatsApp Business es actualmente tu canal activo. Para volver a WhatsApp gratis, tu número se desconecta de la API de Meta y después vuelves a vincular tu teléfono con un código QR. El respaldo por SMS cubre la transición. Atención: Meta puede volver a bloquear el canal gratuito."
      },
      "CLOUD": {
          "dialogWindowNote": "Recipients who have not messaged you in the last 24 hours receive the approved template wording; your edits only reach recipients within the 24-hour window.",
          "windowAllOpen": "All recipients are within the 24-hour window — your text is sent over WhatsApp exactly as written.",
          "windowSomeClosed": "{{count}} of {{total}} recipient(s) are outside the 24-hour window — they receive the approved template wording.",
          "windowEditedWarning": "Careful: you edited the text. The {{count}} recipient(s) outside the 24-hour window will still receive the APPROVED TEMPLATE wording — your edits only reach recipients within the window.",
          "auxTemplateOutOfWindow": "Los destinatarios fuera de la ventana de 24 horas reciben el enlace UP y las propuestas de vuelo como mensaje de plantilla fija (texto definido por Quick Release, no editable).",
          "noFlightTypesHidden": "This booking has no flight planned yet — templates that carry flight details (invitation, reminder, check-in, cancellation) are therefore hidden.",
          "windowClosedFreeform": "Outside the 24-hour window — use a template.",
          "templatePickerButton": "template",
          "title": "WhatsApp channel",
          "subtitle": "Choose how WhatsApp messages are sent: WhatsApp free (linked device) or WhatsApp Business (official, via your own Meta account). You can switch in both directions.",
          "intro": "WhatsApp Business sends your messages over the official Meta API: no linked phone, no risk of being blocked, and delivery confirmations per message.",
          "introBilling": "It is a paid channel: you connect your own Meta business account with your own payment method, and Meta bills you directly. Quick Release does not charge for these messages.",
          "introCostEstimate": "Estimate based on your messages from the past {{months}} months: ± {{cost}} per month. On average you sent {{total}} WhatsApp messages per month, of which ± {{billable}} fell outside the 24h window — only those are paid (± €0.03 per message); messages within 24h of a customer reply are free.",
          "introCostEstimateSms": "Estimate based on your SMS history from the past {{months}} months: ± {{cost}} per month. On average you sent {{total}} messages per month, of which ± {{billable}} would fall outside the 24h window — only those are paid (± €0.03 per message); messages within 24h of a customer reply are free.",
          "introTemplates": "Messages outside a 24-hour customer window are sent with your approved message templates; replies within the window remain free-form and free of charge.",
          "startSignup": "connect with Meta",
          "reconnectMeta": "reconnect Meta account",
          "signupCancelled": "Meta signup was not completed. Your current WhatsApp settings are unchanged.",
          "signupSuccess": "WhatsApp Business account connected {{phone}}. Your message templates are being prepared.",
          "provisioningIntro": "Your Meta account is connected. Complete the steps below, then activate WhatsApp Business. Until then your messages keep using the current channel.",
          "stepWaba": "WhatsApp Business account connected",
          "stepNumber": "Phone number registered",
          "stepPayment": "Payment method added in Meta Business Suite",
          "stepTemplates": "Message templates approved by Meta",
          "paymentExplain": "Meta bills you directly on your own account. Add a payment method in Meta Business Suite (Billing), then confirm here. Without it, template messages will stop sending.",
          "openMetaBilling": "open Meta billing",
          "paymentConfirm": "I added my payment method",
          "paymentActionNeeded": "Meta reported a payment problem on your account. Messages are falling back to SMS. Check your payment method in Meta Business Suite and confirm below.",
          "activate": "activate WhatsApp Business",
          "activateConfirmTitle": "Activate WhatsApp Business?",
          "activateConfirmBody": "From now on your WhatsApp messages are sent via the official Meta API on your own account. You can switch back at any time.",
          "activateConfirmBodyNoPayment": "You have not confirmed a payment method yet. Free messages will work, but paid template messages will fail to SMS until Meta has a payment method. Activate anyway?",
          "activated": "WhatsApp Business is active.",
          "activeTitle": "WhatsApp Business active",
          "messagingTier": "messaging limit",
          "templatesServing": "{{count}} message template(s) approved and in use.",
          "switchBack": "switch back to WhatsApp free",
          "switchBackConfirmTitle": "Switch back to WhatsApp free?",
          "switchBackConfirmBody": "Your number is released from the Meta API and you pair it again as a linked device (QR code). SMS fallback covers the gap during the switch. Note: the free channel can be blocked by Meta again.",
          "switchedBack": "Switched back to WhatsApp free. Pair your phone with the QR code below.",
          "statusApproved": "approved",
          "statusPending": "waiting for Meta approval",
          "statusPendingSince": "waiting for Meta approval for {{elapsed}}",
          "statusRejected": "rejected by Meta",
          "statusBlocked": "wording needs a fix",
          "fixWordingHint": "Fix the wording in the message templates screen and save - it is then automatically resubmitted to Meta.",
          "freeChannelNote": "WhatsApp free works via a linked device on an unofficial connection; Meta can block or disconnect it. Consider WhatsApp Business for a guaranteed channel.",
          "metaLinksHint": "Your account, your number and the template review live at Meta — check them in WhatsApp Manager on your own account.",
          "openMetaAccount": "open WhatsApp Manager",
          "openMetaTemplates": "message templates at Meta",
          "openMetaNumbers": "phone numbers at Meta",
          "beforeYouStart": "before you start, at Meta",
          "prereqBusiness": "A Meta business account (Meta Business Portfolio) in your company's name — create it first if you do not have one.",
          "prereqPayment": "A payment method on that Meta account: Meta bills the paid messages directly to you.",
          "prereqNumber": "A phone number for WhatsApp: a new number, or your current WhatsApp Business number (it keeps working on your phone).",
          "openMetaBusiness": "open Meta Business",
          "openManual": "read the manual"
      },
      "settings": "configuración",
      "whatsapp_OFF": "WhatsApp está desactivado",
      "whatsapp_OFF_hint": "Contáctenos para activar WhatsApp si tiene un número de WhatsApp Business. WhatsApp con su número privado no está soportado.",
      "whatsapp_ON": "WhatsApp está activado",
      "whatsapp_ON_hint": "Todos los mensajes se envían por WhatsApp. Elija usar SMS como respaldo si WhatsApp no está disponible para su cliente.",
      "whatsapp_TRIAL": "WhatsApp está en modo de prueba",
      "whatsapp_TRIAL_hint": "Siempre se le preguntará si prefiere SMS o WhatsApp.",
      "fallbackSMS": "respaldo a SMS",
      "fallbackSMS_hint": "usar SMS si WhatsApp no está disponible",
      "fallbackSMS_no_credits": "sin créditos SMS disponibles. Recargue para activar el respaldo por SMS.",
      "connection": "conexión",
      "device_connected_successfully": "dispositivo conectado correctamente",
      "connect_your_device": "conecte su dispositivo",
      "connect": "conectar",
      "disconnect": "desconectar",
      "device": "dispositivo",
      "phone": "teléfono",
      "checking_device": "verificando dispositivo",
      "not_supported_wa_message": "mensaje de WhatsApp no soportado"
    }
  },
  "DASHBOARDS": {
    "flights": "vuelos",
    "no_flights": "sin vuelos",
    "upcoming": "próximos",
    "historical": "finalizados",
    "this_month": "este mes",
    "bookings": "reservas abiertas",
    "vouchers": "bonos",
    "open": "abiertos",
    "completed": "completados",
    "expired": "expirados",
    "idea_voting": "votación de ideas",
    "search": "buscar",
    "payments": "pagos",
    "charts": "gráficos",
    "flights_of_today_and_tomorrow_morning": "todos los vuelos de hoy y mañana por la mañana",
    "flights_of_next_7_days": "todos los vuelos de los próximos 7 días",
    "bookings_to_confirm_bookmarked_and_of_today_or_tomorrow_morning": "todas las reservas por confirmar, marcadas o reservadas para hoy o mañana por la mañana, las nuevas reservas o con etiqueta de panel",
    "basic_charts_of_reservations_and_flights": "gráficos básicos de reservas y vuelos",
    "charts_are_no_longer_shown_on_the_dashboard_please_navigate_to_reports": "los gráficos ya no se muestran en el panel, por favor navegue a informes",
    "navigate_to_reports": "Ir a informes",
    "most_recent_sms_per_contact": "conversaciones más recientes",
    "messages_bookings": "mensajes reservas",
    "messages_crew": "mensajes tripulación",
    "messages": "mensajes",
    "sms_bookings": "SMS reservas",
    "sms_crew": "SMS tripulación",
    "show_all_messages": "todos",
    "show_messags_from_this_flight": "mostrar solo este vuelo",
    "show_messages_from_this_booking": "mostrar solo esta reserva",
    "show_unread": "no leídos"
  },
  "FLIGHTS": {
    "LIST_FILTER": {
    	"upcoming": "próximos",
    	"upcoming_desc": "aún por volar o de los últimos 7 días",
    	"older": "sin cerrar (anteriores)",
    	"older_desc": "vuelos programados hace más de 7 días, aún sin cerrar",
    	"historical": "finalizados",
    	"historical_desc": "volados o cancelados"
    },
    "show_expired_on_flight_date": "mostrar caducadas en la fecha del vuelo ({{n}})",
    "BULK": {
      "selected": "{{count}} seleccionado(s) (máx. {{limit}})",
      "clear_selection": "Borrar selección",
      "select_all_matching": "Seleccionar todos los vuelos filtrados",
      "actions": "Acción masiva",
      "choose_action": "Elegir acción",
      "deselect_all": "Deseleccionar todo",
      "make_public": "Hacer público",
      "make_private": "Hacer privado",
      "download_csv": "Descargar CSV",
      "ACTION": {
        "SET_VISIBILITY_PUB": "Hacer públicos los vuelos",
        "SET_VISIBILITY_PRI": "Hacer privados los vuelos",
        "ADD_TAG": "Añadir etiqueta",
        "REMOVE_TAG": "Quitar etiqueta",
        "CANCEL": "Cancelar vuelos",
        "DELETE": "Eliminar vuelos"
      },
      "recent_actions": "Acciones masivas de las últimas 24 horas",
      "no_recent_actions": "Ninguna acción masiva en las últimas 24 horas",
      "undone": "deshecha",
      "undone_by": "Deshecha por {{user}}",
      "too_many_matches": "{{total}} vuelos coinciden con este filtro. Una acción masiva está limitada a {{limit}} vuelos a la vez. Acote la búsqueda, el período o el filtro de etiquetas, por ejemplo mes a mes.",
      "limit_reached": "Puede seleccionar como máximo {{limit}} vuelos para una acción masiva. Acote la búsqueda, el período o el filtro de etiquetas.",
      "no_matches": "Ningún vuelo coincide con este filtro.",
      "confirm_selected": "{{count}} vuelos seleccionados.",
      "date_range": "Período",
      "will_update": "{{count}} se modificarán",
      "will_stay_unchanged": "{{count}} ya tienen este ajuste",
      "will_skip": "{{count}} se omitirán",
      "undo_hint": "Puede deshacer esta acción una vez dentro de las 24 horas.",
      "apply": "Aplicar a {{count}} vuelos",
      "updated": "{{count}} modificados",
      "unchanged": "{{count}} sin cambios",
      "skipped": "{{count}} omitidos",
      "restored": "{{count}} restaurados",
      "not_restored": "{{count}} no restaurados",
      "undo": "Deshacer",
      "undo_available_until": "Deshacer posible hasta",
      "SKIP": {
        "NOT_FOUND": "el vuelo ya no existe",
        "NOT_UPCOMING": "el vuelo está cancelado o finalizado",
        "HAS_BOOKINGS_FUTURE": "tiene reservas: cancélelo individualmente para que se informe a los pasajeros",
        "HAS_BOOKINGS": "tiene reservas",
        "NOT_SCHEDULED": "solo se pueden eliminar vuelos planificados",
        "ERROR": "error inesperado"
      },
      "UNDO_SKIP": {
        "CHANGED_SINCE": "modificado desde entonces, no restaurado",
        "NOT_FOUND": "el vuelo ya no existe",
        "DELETED": "reserva eliminada",
        "ON_OTHER_FLIGHT": "reserva planificada en otro vuelo",
        "NOT_OPEN": "reserva ya no abierta",
        "ERROR": "error inesperado"
      }
    },
    "CANCEL": {
      "title": "cancelar vuelo",
      "reason_from_message": "motivo: {{reason}}",
      "change_reason": "cambiar",
      "cancel_and_send": "cancelar y enviar mensaje",
      "cancel_and_send_crew": "cancelar y enviar mensaje + tripulación",
      "cancel_only": "solo cancelar",
      "cancel_only_warning": "los pasajeros no serán avisados",
      "confirm": "confirmar",
      "already_sent": "mensaje de cancelación ya enviado",
      "send_failed": "no se pudo enviar el mensaje — el vuelo no se ha cancelado",
      "back": "volver"
    },
    "cancel_message_only": "enviar solo el mensaje de cancelación",
    "cancel_message_sent_chip": "mensaje de cancelación enviado — vuelo aún no cancelado",
    "passengers_not_notified": "los pasajeros no han sido avisados",
    "CHECKIN_LOG": {
    	"title": "check-in del piloto",
    	"empty": "sin cambios durante el check-in móvil",
    	"signoff_cleared": "firma del piloto borrada",
    	"signoff_signed": "el piloto ha firmado"
    },
    "cancelled_bookings": {
      "title": "pasajeros en la cancelación",
      "send_message": "enviar mensaje de cancelación",
      "restore": "restaurar el vuelo",
      "restore_confirm": "El vuelo se restaurará y los pasajeros que estaban en él se añadirán de nuevo. Las reservas colocadas entre tanto en otro vuelo no se modifican.",
      "restore_done": "Vuelo restaurado, {{count}} reserva(s) reasignada(s).",
      "restore_skipped": "No restaurado: {{skipped}}.",
      "skip_DELETED": "la reserva ya no existe",
      "skip_ON_OTHER_FLIGHT": "entre tanto en otro vuelo",
      "skip_NOT_OPEN": "la reserva ya no está abierta"
    },
    "save": "guardar",
    "reset": "restablecer predeterminado",
    "unknown": "desconocido",
    "CON": "confirmado",
    "invited_by_sms": "invitado por sms",
    "DEC": "rechazado",
    "MOR": "mañana",
    "EVE": "tarde",
    "CPF": "vuelo comercial privado",
    "COF": "vuelo comercial",
    "NCF": "vuelo no comercial",
    "PRI": "no compartido",
    "PUB": "compartido",
    "SCH": "programado",
    "REA": "listo",
    "MARK": {
      "SCH": "programar",
      "REA": "poner listo",
      "CAN": "cancelar",
      "FIN": "finalizar"
    },
    "INFO": {
      "SCH": "prepare todo y establezca listo para volar",
      "REA": "¡bien hecho! Este vuelo está listo para despegar",
      "CAN": "este vuelo está cancelado, puede eliminarlo del sistema",
      "FIN": "este vuelo ha terminado, ¡excelente trabajo!"
    },
    "checkin": "check-in",
    "CAN": "cancelado",
    "FIN": "finalizado",
    "balloon": "globo aerostático",
    "date": "fecha",
    "period": "período",
    "event": "evento",
    "hour": "hora",
    "hourMeeting": "hora de encuentro",
    "sunrise": "amanecer",
    "sunset": "atardecer",
    "flight_type": "tipo de vuelo",
    "location": "ubicación",
    "visibility": "visibilidad",
    "web": "web",
    "status": "estado",
    "comment": "comentario",
    "crew_comments": "comentarios de la tripulación",
    "pilot": "piloto",
    "pilot_status": "estado",
    "action_needed": "acción requerida",
    "ground_crew": "tripulación de tierra",
    "pilot_and_crew": "piloto y tripulación",
    "not_enough_data": "datos insuficientes",
    "answer_pilot_yes_no": "Responda PILOTO SÍ o PILOTO NO.",
    "pilot_yes": "PILOTO SÍ",
    "pilot_no": "PILOTO NO",
    "Flight date cannot be set in the past": "La fecha del vuelo no puede ser en el pasado",
    "answer_crew_yes_no": "Responda TRIPULACIÓN SÍ o TRIPULACIÓN NO.",
    "crew_yes": "TRIPULACIÓN SÍ",
    "crew_no": "TRIPULACIÓN NO",
    "flights": "vuelos",
    "flight_bookings": "reservas del vuelo",
    "UNK": "añadido",
    "INV": "invitado por sms",
    "invite_all": "SMS invitar a todos",
    "inviteCount": "invitaciones",
    "invite_count_1": "invitación",
    "mo": "lu",
    "tu": "ma",
    "we": "mi",
    "th": "ju",
    "fr": "vi",
    "sa": "sa",
    "su": "do",
    "invite": "enviar sms",
    "mail": "correo",
    "reply": "Escriba aquí su mensaje de respuesta",
    "sms": "sms",
    "whatsapp": "WhatsApp",
    "whatsapp_sms": "WhatsApp (respaldo sms)",
    "message": "mensaje",
    "message_whatsapp": "mensaje WhatsApp",
    "message_sms_fallback": "mensaje SMS de respaldo",
    "confirm": "confirmar",
    "remove": "eliminar",
    "contactName": "nombre de contacto",
    "bookingType": "tipo de reserva",
    "region": "región",
    "passengers": "pasajeros",
    "no_bookings_selected": "ninguna reserva seleccionada",
    "matching_bookings": "reservas",
    "mismatching_bookings": "reservas en otro vuelo",
    "mismatchReasons": "coincidencia de vuelo",
    "add_all": "añadir todos",
    "add": "añadir",
    "add_and_confirm": "añadir + confirmar",
    "already_added": "ya añadido",
    "messages": "mensajes",
    "calendar": "calendario",
    "download_manifest": "descargar manifiesto",
    "send_sms_reminder": "enviar recordatorio por sms",
    "update": "actualizar",
    "are_you_sure": "¿está seguro?",
    "reminder_sms_will_be_sent": "se enviará un SMS de recordatorio",
    "edit_sms": "editar SMS",
    "edit_wa": "editar WhatsApp",
    "preview_sms": "vista previa",
    "send": "enviar",
    "send_to_pax": "enviar a pasajeros",
    "send_to_pax_and_crew": "enviar a pasajeros y tripulación",
    "send_up_url_with_sms": "enviar URL de UP con SMS",
    "send_up_url_with_msg": "enviar URL de UP con MSG",
    "upTitle": "¡Acceda directamente a su página de reserva personal a través de este enlace!\n[se enviará enlace personal]",
    "flightOptions": "opciones de vuelo",
    "flightOptionsTitle": "Estaríamos encantados de recibirle en una de las siguientes fechas:\n[se enviará lista personal de vuelos con plazas disponibles]",
    "send_flightoptions_with_msg": "enviar opciones de vuelo con MSG",
    "sent": "enviado",
    "message_has_been_sent": "el mensaje ha sido enviado",
    "message_has_not_been_sent": "el mensaje no ha sido enviado",
    "not_sent": "no enviado",
    "not_confirmed_bookings_will_be_removed_from_flight": "las siguientes reservas no confirmadas serán eliminadas del vuelo",
    "flight_will_be_cancelled": "el vuelo será cancelado",
    "flight_will_be_finished": "el vuelo será finalizado",
    "flight_will_be_reopened": "el vuelo volverá a la planificación",
    "yes_cancel_it": "sí, cancelar",
    "no_please": "no, por favor",
    "cancel_sms_will_be_sent": "se enviará SMS de cancelación",
    "not_cancelled": "no cancelado",
    "flight_has_not_been_cancelled": "el vuelo no ha sido cancelado",
    "confirm_message": "¿está seguro de que desea eliminar este vuelo?",
    "flight_pilot_in_command": "piloto al mando del vuelo",
    "invite_by_sms": "enviar sms",
    "unsupported_phonenumber": "número de teléfono no soportado",
    "sms_unclear": "sms confuso",
    "no_pilot_in_command_selected": "no se ha seleccionado piloto al mando",
    "flight_crew": "tripulación del vuelo",
    "no_crew_selected": "no se ha seleccionado tripulación",
    "available_pilots_and_crew": "pilotos y tripulación disponibles",
    "select_pilot": "seleccionar piloto",
    "select_crew": "seleccionar tripulación",
    "other_flight": "otro vuelo",
    "add_as_crew": "añadir como tripulación",
    "add_as_pilot": "añadir como piloto",
    "warning": "advertencia",
    "creating_a_flight_can_lead_to_costs": "esta acción puede generar costos",
    "proceed": "continuar",
    "cancel": "cancelar",
    "passenger_count": "número de pasajeros",
    "crew_count": "número de tripulación",
    "type": "tipo",
    "no_pilot": "sin piloto",
    "seats": "plazas",
    "delete": "eliminar",
    "set_ready": "listo",
    "address": "dirección",
    "postalCode": "CP",
    "city": "ciudad",
    "country": "país",
    "manifest": "manifiesto",
    "certificates": "certificados",
    "takeoffTime": "hora de despegue (LT)",
    "landingLocation": "ubicación de aterrizaje",
    "landingDetails": "detalles de aterrizaje",
    "total_weight": "peso total",
    "landingTime": "hora de aterrizaje (LT)",
    "flightTime": "tiempo de vuelo",
    "and": "y",
    "name": "nombre",
    "ref": "ref",
    "amount": "importe (EUR)",
    "weight": "peso",
    "signature": "firma",
    "reminder_sms": "SMS de recordatorio",
    "also_to_pilot_and_crew": "también a piloto y tripulación",
    "cancel_sms": "SMS de cancelación",
    "no_flights_found": "no se encontraron vuelos",
    "no_location": "sin ubicación",
    "show": "mostrar",
    "hide": "ocultar",
    "lift": "sustentación",
    "lift_needed": "sustentación requerida",
    "lift_available": "sustentación disponible",
    "lift_spare": "sustentación de reserva",
    "lift_level_green": "margen de sustentación OK",
    "lift_level_orange": "reserva de sustentación baja",
    "lift_level_red": "sustentación de reserva demasiado baja",
    "lift_level_blue": "infracargado — puede aterrizar por debajo de la masa mínima de aterrizaje (MLM)",
    "lift_level_unknown": "datos de sustentación incompletos",
    "takeoff_location": "Ubicación de Despegue",
    "takeoff_height": "elevación de despegue",
    "maximum_height": "altitud máxima",
    "temp_takeoff": "temperatura de despegue",
    "temp_takeoff_manual_hint": "introducida manualmente — haga clic para volver a usar la temperatura de Meteoblue",
    "temp": "temperatura",
    "temp_max": "temperatura a altitud máxima",
    "weather_qfe": "presión de despegue (QNH)",
    "weather_pmax": "presión a altitud máxima",
    "balloon_volume": "volumen del globo",
    "balloon_temp": "temp máx envoltura",
    "create_add": "añadir a nuevo vuelo",
    "weather": "meteorología",
    "copy_weather_to": "copiar meteorología a",
    "use_meteoblue": "usar meteoblue",
    "skeyes_ballooning_bulletin": "boletín de aerostación skeyes",
    "use_skeyes": "usar Skeyes",
    "weather_forecast": "pronóstico meteorológico",
    "no_weather_forecast": "sin pronóstico disponible",
    "windSummary": "resumen de vientos",
    "weather_source": "fuente",
    "weather_source_forced": "fuente oficial (ajustes meteorológicos)",
    "weather_forecast_date": "fecha del pronóstico",
    "vfr_visual": "visibilidad",
    "vfr_clouds": "nubes",
    "wind_gl": "viento a nivel del suelo",
    "wind_gl_short": "viento NS",
    "wind_dir": "dirección",
    "wind_gl_direction": "dirección del viento a nivel del suelo",
    "wind_10": "viento 1000FT",
    "wind_10_direction": "dirección del viento 1000FT",
    "wind_20": "viento 2000FT",
    "wind_20_direction": "dirección del viento 2000FT",
    "wind": "viento",
    "clear": "despejado",
    "fuel_spare": "combustible de reserva",
    "planned_flight_time": "tiempo de vuelo planificado",
    "spare_flight_time": "tiempo de vuelo de reserva",
    "maximum_flight_time": "tiempo de vuelo disponible",
    "select_balloon": "seleccione el globo",
    "select_location": "seleccione la ubicación",
    "offsets": "cambiar desfases de amanecer/atardecer",
    "flight_hour_will_be_calculated_based_on_sunset_minus_the_offset_minutes": "la hora del vuelo se calcula basándose en el atardecer (o amanecer) menos los minutos de desfase, redondeado a la media hora. Se permiten valores negativos (en caso de amanecer).",
    "offset_sunrise": "desfase amanecer (minutos)",
    "offset_sunset": "desfase atardecer (minutos)",
    "payment_overview": "resumen de pagos",
    "go_back": "volver",
    "freeSpots": "plazas libres",
    "traject": {
      "trajectory": "trayectoria",
      "custom_flight_profile": "perfil de vuelo personalizado",
      "duration": "duración",
      "duration_is_required": "la duración es requerida",
      "level": "nivel",
      "level_is_required": "el nivel es requerido",
      "save": "guardar",
      "no_trajectory_without_meteo": "sin trayectoria sin meteorología",
      "update_custom_profile": "actualizar perfil personalizado",
      "refresh_weather": "actualizar meteorología",
      "talking_to_meteoblue": "comunicando con meteoblue",
      "refresh_hint": "meteoblue actualiza su modelo meteorológico con frecuencia. La actualización vuelve a estar disponible 4 horas después de la última actualización."
    },
    "LANDING": {
      "landing": "aterrizaje",
      "landing_details": "detalles",
      "map": "mapa",
      "no_details": "sin detalles disponibles",
      "landing_data": "los datos de aterrizaje solo pueden cambiarse en la pantalla de check-in móvil por ahora",
      "refuelVolume": "volumen de recarga de gas",
      "update_log": "actualizar registro",
      "update_log_hint": "solo puede cambiar los datos de aterrizaje aquí. Abra el vuelo para cambiar todos los demás datos del vuelo.",
      "open_flight": "abrir vuelo"
    },
    "FILTER": {
      "date_range_filter": "filtro de rango de fechas",
      "from": "desde",
      "till": "hasta",
      "excluded": "excluido",
      "no_date_filter_active": "sin filtro de fecha activo",
      "enter_a_date_range": "introduzca un rango de fechas",
      "start_date": "fecha de inicio",
      "end_date": "fecha de fin",
      "month": "mes",
      "week": "semana",
      "day": "día",
      "flights": "vuelos"
    },
    "flight_no_bookings": "este vuelo aún no tiene reservas",
    "mor_flight": "vuelo matutino",
    "eve_flight": "vuelo vespertino",
    "mor_flights": "vuelos matutinos",
    "eve_flights": "vuelos vespertinos",
    "no_mor_flights": "sin vuelos matutinos",
    "no_eve_flights": "sin vuelos vespertinos",
    "responded_pilots": "pilotos que respondieron",
    "delete_flight": "eliminar vuelo",
    "toggle_visibility": "cambiar visibilidad",
    "tags": "etiquetas",
    "COPY": {
      "copy_flight": "copiar vuelo",
      "select_multiple_dates": "seleccione múltiples fechas para copiar el mismo vuelo con la misma ubicación, globo, piloto y tripulación",
      "selected_dates": "fechas seleccionadas",
      "no_tags": "sin etiquetas",
      "copy": "copiar"
    },
    "PILOTANDCREW": {
      "selected": "seleccionado",
      "most_used": "más usado",
      "this_is_the_most_used_pilot_and_crew": "este es el piloto y tripulación más usados para este globo",
      "accept": "aceptar",
      "all_pilots_and_crew": "todos los pilotos y tripulación",
      "select": "seleccionar"
    },
    "FREESPOTS": {
      "showAll": "Mostrar todos los vuelos",
      "showOverbookings": "Mostrar sobrereservas",
      "freeSpots": "Mostrar todos los vuelos con {{count}} o más plazas libres",
      "showMore": "Mostrar más opciones"
    },
    "selected_flight": "Vuelo seleccionado",
    "selected_flight_hint": "Esta reserva está actualmente programada para este vuelo",
    "possible_flights": "Próximos vuelos",
    "possible_flights_hint": "Estos son los próximos vuelos para los que esta reserva puede programarse, teniendo en cuenta las plazas disponibles y las restricciones de etiquetas",
    "balloon_cannot_accept_passengers": "El globo no puede aceptar pasajeros",
    "balloon_in_use_tooltip": "El globo está siendo usado en otro vuelo con pasajeros. Cambie a otro globo para añadir pasajeros aquí.",
    "reduce_capacity_by_one_pax": "Reducir capacidad en un pasajero",
    "reset_capacity": "Restablecer capacidad",
    "has_open_amount_tooltip": "Este vuelo tiene reservas con saldo pendiente"
  },
  "DISPLAYEDCOLUMNS": {
    "hint": "Seleccione columnas y cambie el orden con arrastrar y soltar como prefiera",
    "warning": "Atención, necesita restablecer sus preferencias después de cambios en las definiciones de columnas",
    "flightsUpcoming": "Columnas para próximos vuelos",
    "flightsBooking": "Columnas para vuelos desde reservas",
    "flightsHistory": "Columnas para vuelos históricos",
    "bookingsOpen": "Columnas para reservas abiertas",
    "bookingsHistory": "Columnas para reservas históricas",
    "bookingsPayment": "Columnas para seguimiento de pagos",
    "bookingsDashboard": "Columnas para panel de reservas",
    "bookingsFlight": "Columnas para reservas en un vuelo",
    "bookingsFlightEnd": "Columnas para reservas en vuelo finalizado",
    "bookingsFlightCancelled": "Columnas para reservas de un vuelo cancelado",
    "bookingsFlightAll": "Columnas para reservas en un vuelo",
    "bookingsFlightPayment": "Columnas para seguimiento de pagos",
    "status": "estado",
    "name": "globo",
    "nameBadge": "globo",
    "date": "fecha",
    "event": "evento",
    "hour": "hora",
    "location": "ubicación",
    "pilot": "piloto",
    "crew": "tripulación",
    "bookings": "reservas",
    "comments": "comentarios",
    "passengers": "pasajeros",
    "passengersWeight": "peso",
    "action": "acción",
    "bookingDate": "fecha de reserva",
    "contactName": "nombre de contacto",
    "phone": "teléfono",
    "region": "región",
    "city": "ciudad",
    "preferredDate": "disponibilidad",
    "flightDate": "fecha del vuelo",
    "flightPeriod": "período del vuelo",
    "flight_balloon": "globo del vuelo",
    "flight_location": "ubicación del vuelo",
    "flight_pilot": "piloto del vuelo",
    "totalAmount": "importe total",
    "paid_amount": "pagado",
    "openAmount": "saldo",
    "flight_confirmation": "confirmar vuelo",
    "messages": "mensajes",
    "up": "UP",
    "contactCard": "reserva",
    "passengersCard": "pasajeros",
    "mismatchReasons": "coincidencia de vuelo",
    "mobile_view": "visible en móvil"
  },
  "MANIFEST": {
    "fuel_consumption": "consumo de combustible",
    "fuel_needed": "combustible necesario",
    "fuel_available": "combustible disponible",
    "load_chart_and_passenger_list": "Cálculos de Carga y Lista de Pasajeros",
    "passenger_list": "Lista de Pasajeros",
    "weather_conditions": "Condiciones Meteorológicas",
    "fuel_calculations": "Cálculos de Combustible",
    "load_chart": "Cálculos de Carga",
    "after_flight": "Después del Vuelo",
    "visible_defects": "Defectos Visibles",
    "yes_no": "Sí/No",
    "date": "fecha",
    "signature": "firma",
    "defect": "defecto",
    "action": "acción",
    "certificate": "certificado",
    "authority": "autoridad",
    "initials": "iniciales",
    "confirmation": "esto confirma que las acciones especificadas fueron ejecutadas según PART-ML y que la aeronave se declara lista para el próximo vuelo."
  },
  "LOCATIONS": {
    "name": "nombre",
    "description": "descripción",
    "region": "región",
    "address": "dirección",
    "postalCode": "código postal",
    "city": "ciudad",
    "country": "país",
    "height": "elevación de despegue",
    "maximum height": "altitud máxima",
    "locations": "ubicaciones",
    "confirm_message": "¿está seguro de que desea eliminar?",
    "confirm": "confirmar",
    "update": "actualizar",
    "delete": "eliminar",
    "regions": "regiones",
    "save": "guardar",
    "add_location": "añadir ubicación",
    "add_region": "añadir región",
    "hot_airfield": "campo caliente",
    "coordinates": "coordenadas",
    "geolocate": "geolocalizar",
    "no_results": "sin resultados",
    "contact": "contacto",
    "takeoff_location": "Ubicación de Despegue",
    "takeoff_location_subtitle": "Las coordenadas de la ubicación de despegue se usan para el pronóstico meteorológico, trayectoria y cálculo de sustentación.",
    "meetingpoint": "punto de encuentro",
    "meetingpoint_subtitle": "La dirección del punto de encuentro se comunica a los pasajeros (UP).",
    "same_as_takeoff": "igual que ubicación de despegue",
    "meetingpointAddress": "dirección del punto de encuentro",
    "search_address": "buscar dirección",
    "CONTACT": {
      "name": "nombre",
      "type": "tipo",
      "comment": "comentario",
      "phone": "teléfono",
      "email": "correo electrónico",
      "when_to_contact": "cuándo contactar",
      "how_to_contact": "cómo contactar",
      "NOMSG": "sin mensaje",
      "MAIL": "correo electrónico",
      "SMS": "msg",
      "mail": "durante la preparación del vuelo, podrá enviar un correo electrónico a la persona de contacto",
      "sms": "durante la preparación del vuelo, podrá enviar un msg a la persona de contacto",
      "no_message": "no se enviará mensaje a la persona de contacto",
      "add_sms_template": "añadir plantilla de msg",
      "add_mail_template": "añadir plantilla de correo",
      "mail_template": "plantilla de correo",
      "sms_template": "plantilla de msg",
      "warning_email": "no ha enviado un correo electrónico a la persona de contacto",
      "warning_sms": "no ha enviado un sms a la persona de contacto"
    }
  },
  "FLYABILITY": {
    "verdict_good": "bueno para volar",
    "verdict_marginal": "dudoso",
    "verdict_nogo": "probablemente no volable",
    "no_assessment": "no hay evaluación disponible",
    "all_within_limits": "todos los parámetros dentro de tus límites",
    "unknown_excluded": "sin datos para {{parameters}} — no contabilizado",
    "advisory": "Esta valoración es solo una ayuda basada en tus propios límites: el piloto al mando decide.",
    "param_windGl": "viento en superficie",
    "param_wind500": "viento a 500 m",
    "param_gustSpread": "rachas por encima del viento en superficie",
    "param_precipitation": "precipitación",
    "param_lowClouds": "nubes bajas",
    "param_visibility": "visibilidad"
  },
  "FORECAST": {
    "no_mobile": "La meteorología actualmente solo está soportada en pantallas más grandes",
    "select_favorite": "Seleccione una ubicación como favorita para mostrar el pronóstico meteorológico de meteoblue",
    "no_forecast": "No hay meteorología disponible para esta ubicación. Verifique latitud y longitud",
    "remove_favorite": "quitar favorito",
    "mark_favorite": "marcar favorito",
    "favorite_description": "esta ubicación es su ubicación favorita. El pronóstico meteorológico de meteoblue está disponible en el panel para esta ubicación.",
    "non_favorite_description": "esta ubicación no es su ubicación favorita. Márquela como favorita para mostrar el pronóstico meteorológico de meteoblue en el panel",
    "meteo": "meteorología",
    "time": "hora",
    "summary": "resumen"
  },
  "REGIONS": {
    "name": "nombre",
    "locations": "ubicaciones",
    "no_locations_yet": "aún sin ubicaciones",
    "name_required": "nombre requerido",
    "change_color": "clic aquí para cambiar el color de la región",
    "reset_color": "restablecer color",
    "confirm_color": "confirmar color",
    "cancel_color": "cancelar color",
    "openBookings": "reservas abiertas",
    "notusedyet": "aún sin reservas",
    "move": "mover todas las reservas a otra región",
    "select_target_region": "seleccione la región destino para todas las {0} reservas en esta región"
  },
  "EVENTS": {
    "new_event": "nuevo evento",
    "information": "añada un evento en una fecha específica o cargue los días festivos",
    "new_crew_event": "nueva cita",
    "crew_information": "añada una cita ocupada (no disponible para volar o tripular)",
    "holidays": "festivos",
    "load_public_holidays_of_year_from_country": "cargar días festivos de {0} desde {1}",
    "date": "fecha",
    "description": "descripción",
    "save": "guardar",
    "cancel": "cancelar",
    "required": "requerido",
    "crew": "tripulación",
    "NO": "no disponible",
    "YES": "disponible",
    "MAYBE": "quizás disponible",
    "UNK": "disponibilidad desconocida",
    "comment_availability": "¿Qué debemos tener en cuenta el",
    "comment": "comentario"
  },
  "SETTINGS": {
    "VARIANTS": {
      "duplicate": "duplicar",
      "copySuffix": "(copia)",
      "reasonCode": "motivo de cancelación",
      "reasonCodeHint": "Al elegir este motivo al cancelar, este mensaje queda preseleccionado. Un motivo pertenece a un solo mensaje.",
      "reasonGeneral": "— ninguno (mensaje general) —",
      "reasonTaken": "usado por {{label}}",
      "reasonRemoved": "(motivo eliminado)",
      "default": "predeterminado",
            "add": "add variant",
            "remove": "remove variant",
            "label": "variant name",
            "labelHint": "Optional — distinguishes several wordings of the same message type (e.g. \"morning flight\", \"short notice\").",
            "picker": "wording",
            "variant": "variant",
            "waIssues": "WhatsApp Business cannot submit this wording",
            "waRejected": "Rejected by Meta",
            "waResubmitHint": "Adjust the wording and save — it is automatically resubmitted to Meta for approval.",
            "wabaColumn": "WhatsApp status",
            "ISSUES": {
                "VARIABLE_AT_START": "starts with a variable",
                "VARIABLE_AT_END": "ends with a variable",
                "ADJACENT_VARIABLES": "two variables directly after each other",
                "TOO_MANY_VARIABLES": "too many variables for the amount of fixed text",
                "UNKNOWN_PLACEHOLDER": "unknown variable for this message type",
                "TOO_LONG": "text is too long",
                "EMPTY_TEXT": "no text"
            }
        },
    "user_default_language": "idioma predeterminado del usuario",
    "submit": "enviar",
    "preferences_language": "idioma",
    "preferences_sms": "SMS",
    "smsTitle": "título",
    "smsTemplate": "plantilla",
    "pilotInvitationSms": "SMS de invitación a piloto",
    "example": "ejemplo",
    "update": "actualizar",
    "crewInvitationSms": "SMS de invitación a tripulación",
    "passengerInvitationSms": "SMS de invitación a pasajero",
    "cancelSms": "SMS de cancelación",
    "reminderSms": "SMS de recordatorio",
    "locationContactSms": "SMS de contacto de ubicación",
    "checkinNotificationSms": "SMS de notificación de check-in",
    "bookingConfirmationSms": "SMS de confirmación de reserva",
    "platformUpLink": "enlace UP (plantilla fija)",
    "platformFlightOptions": "propuestas de vuelo (plantilla fija)",
    "emailTitle": "título",
    "emailType": "tipo",
    "emailTo": "correo a",
    "emailSubject": "asunto",
    "emailBody": "cuerpo",
    "emailAttachments": "adjuntos",
    "emailAttachments_save_hint": "no olvide guardar su plantilla después de agregar o eliminar adjuntos",
    "emailTest": "prueba de correo",
    "mailFromEmail": "dirección de cuenta de correo",
    "mailFromName": "nombre del remitente",
    "mailReplyToEmail": "correo de respuesta",
    "mailAccountantName": "nombre del correo del contador",
    "mailAccountantEmail": "dirección de correo del contador",
    "bookingConfirmEmail": "Correo de confirmación de reserva",
    "bookingFlightCancelEmail": "Correo de fin de vuelo",
    "bookingFlightConfirmEmail": "Correo a pasajeros de un vuelo",
    "crewFlightEmail": "Correo de detalles de vuelo para tripulación",
    "crewOtpEmail": "Correo de inicio de sesión para tripulación",
    "pilotFlightEmail": "Correo de detalles de vuelo para piloto",
    "flight_email": "Correo de detalles de vuelo",
    "locationContactEmail": "Correo de contacto en ubicación",
    "checkinNotificationEmail": "Correo de notificación de check-in",
    "flight_email_passengers": "Correo a pasajeros",
    "flight_sms_passengers": "SMS a pasajeros",
    "flight_msg_passengers": "MSG a pasajeros",
    "load_default": "cargar texto estándar",
    "passenger_categories": "categorías de pasajeros",
    "category_name": "nombre",
    "category_description": "descripción",
    "category_child": "niño",
    "category_price": "precio",
    "category_default": "predeterminado",
    "delete": "eliminar",
    "mobile_questions": "preguntas para pasajeros (móvil)",
    "question": "pregunta",
    "kind": "tipo",
    "active": "activo",
    "title": "título",
    "description": "descripción",
    "language": "idioma",
    "texts": "textos",
    "name": "nombre",
    "address": "dirección",
    "email": "correo electrónico",
    "weight": "peso",
    "luggage": "equipaje",
    "child": "niño",
    "accompany": "acompañar",
    "pay": "pagar",
    "signature": "firma",
    "optional": "opcional",
    "order": "orden",
    "titles": "preguntas",
    "descriptions": "textos de preguntas",
    "yes": "sí",
    "no": "no",
    "nl": "holandés",
    "fr": "francés",
    "en": "inglés",
    "de": "alemán",
    "es": "español",
    "id": "id",
    "download_sample": "descargar muestra",
    "drag_and_drop_file_here": "arrastre y suelte el archivo aquí",
    "browse_for_file": "buscar archivo",
    "operator_settings": "configuración del operador",
    "operator_backup_and_sync": "respaldo y sincronización",
    "operator_bookings": "configuración de reservas",
    "operator_flights": "configuración de vuelos",
    "operator_crew": "configuración de tripulación",
    "operator_myflight": "configuración de UP (App de Pasajeros)",
    "operator_weather_source": "ajustes de meteo y NOTAM",
    "flyability": {
      "enabled": "mostrar la volabilidad en la tarjeta meteorológica",
      "disabled_hint": "Desactivado: la tarjeta meteorológica y el detalle del vuelo se ven exactamente como hoy, sin valoraciones ni colores. Actívalo para evaluar cada franja de pronóstico según los límites de abajo.",
      "band_good": "bueno",
      "band_marginal": "dudoso",
      "band_nogo": "no volar",
      "explain_windGl": "Velocidad media del viento en superficie durante la ventana de vuelo. Determina si el inflado, el despegue y el aterrizaje pueden hacerse con seguridad: es el límite por el que se cancelan la mayoría de los vuelos.",
      "explain_wind500": "Velocidad del viento a unos 500 metros, la altura donde el globo pasa la mayor parte del vuelo. Fija a qué velocidad y hasta dónde vuelas, y por tanto cuánta zona de aterrizaje necesitas.",
      "explain_gustSpread": "Cuánto más fuertes son las rachas que el viento constante en superficie. Rachas de 8 kt sobre un viento tranquilo de 5 kt siguen suponiendo tirones bruscos de la vela al inflar y al aterrizar: por eso se valora aparte del viento en sí.",
      "explain_precipitation": "La lluvia más intensa prevista durante la ventana de vuelo. Una vela mojada pesa y hay que secarla después, así que la mayoría de los operadores mantienen la zona verde en cero.",
      "explain_lowClouds": "La parte del cielo cubierta por nubes por debajo de unos 2 km. Mucha nube baja significa una base de nubes baja y poca visión del suelo: 0 % es cielo despejado, 100 % está totalmente cubierto.",
      "explain_visibility": "Hasta dónde ves en horizontal. La necesitas para navegar, ver otro tráfico y elegir un campo a tiempo. Es el único parámetro donde más es mejor, así que sus límites cuentan hacia arriba.",
      "title": "límites de volabilidad",
      "hint": "La tarjeta meteorológica colorea cada franja de pronóstico en verde, naranja o rojo según estos límites. Deja un parámetro en su valor por defecto para seguir el valor de la plataforma.",
      "good_upto": "bueno hasta",
      "marginal_upto": "dudoso hasta",
      "good_from": "bueno desde",
      "marginal_from": "dudoso desde",
      "is_default": "por defecto",
      "reset": "restablecer",
      "reset_all": "restablecer todo",
      "saved": "límites de volabilidad guardados",
      "error_required": "ambos valores son obligatorios",
      "error_negative": "los valores no pueden ser negativos",
      "error_order": "el límite bueno no puede ser más estricto que el límite dudoso"
    },
    "weatherSource": {
        "title": "fuente meteorológica oficial por país",
        "hint": "Si está activado, la fuente meteorológica del vuelo y del Operational Flight Plan (OFP) se rellena automáticamente con la fuente oficial del país del lugar de despegue, en lugar de texto libre.",
        "mapped": "forzar la fuente meteorológica oficial por país",
        "source": "fuente meteorológica",
        "locations": "ubicaciones",
        "locationsWithoutCountry": "ubicaciones sin país (por favor indique el país)",
        "addCountry": "añadir país"
    },
    "export": "exportar",
    "you_can_activate_a_daily_backup": "puede enviar una exportación diaria en HTML a una dirección de correo específica. Tan pronto como active la exportación, recibirá inmediatamente una exportación a la dirección de correo dada, y luego cada día alrededor de las 4am",
    "daily_backup": "exportación diaria",
    "backup_email": "dirección de correo",
    "only_update_when_inactive": "solo puede cambiar la dirección de correo cuando la exportación está inactiva",
    "exported_files": "archivos exportados",
    "bookings": "todas las reservas abiertas",
    "flights": "todos los vuelos planificados",
    "vouchers": "todos los bonos",
    "flights_bookings_passengers": "todos los vuelos planificados con sus reservas y pasajeros",
    "calendarUrl": "URL ICS para el calendario",
    "you_can_subscribe_to_all_flights_in_your_personal_calendar": "puede suscribirse a todos los vuelos en su calendario personal",
    "geticsurl": "generar URL ICS",
    "readthedocs": "leer la documentación",
    "crew": {
      "title": "Tripulación",
      "shareBookings": "la tripulación puede ver los detalles de las reservas de un vuelo en el panel",
      "shareBookingsHint": "si no está marcado, la tripulación solo puede ver el número de pasajeros en un vuelo en el panel",
      "allowFlightSelection": "la tripulación puede seleccionar vuelos en el calendario",
      "allowFlightSelectionHint": "si no está marcado, la tripulación solo puede ver los vuelos en el calendario, pero no puede seleccionarlos",
      "shareEvents": "compartir eventos del calendario con la tripulación",
      "shareEventsHint": "si está marcado, los eventos del operador (ej. vacaciones, eventos de empresa) serán visibles para la tripulación en su calendario",
      "shareFlightTags": "compartir etiquetas de vuelo con la tripulación",
      "shareFlightTagsHint": "si está marcado, las etiquetas de vuelo serán visibles para la tripulación en su calendario",
      "crewReady": {
        "title": "Notificación de tripulación lista",
        "channel": "canal de notificación",
        "channelNone": "ninguno (desactivado)",
        "channelEmail": "correo electrónico",
        "channelWhatsApp": "WhatsApp",
        "channelBoth": "Ambos (correo electrónico + WhatsApp)",
        "instructions": "instrucciones para la tripulación",
        "includePassengers": "incluir pasajeros en la notificación",
        "includeTrajectory": "incluir imagen de trayectoria en la notificación",
        "language": "idioma de notificación",
        "hint": "La tripulación es informada automáticamente por WhatsApp o correo electrónico cuando el estado del vuelo cambia a listo. La notificación incluye detalles del vuelo y opcionalmente pasajeros y trayectoria.",
        "preview": "vista previa"
      }
    },
    "operator_notifications": "notificaciones",
    "notifications": {
      "title": "Notificaciones por correo",
      "title_calendar": "Notificación por correo de cambio de disponibilidad",
      "title_flightCrew": "Notificación por correo de cambio de piloto y/o tripulación para un vuelo",
      "calendar": "Recibir un correo cuando cambie la disponibilidad de tripulación y pilotos",
      "calendarHint": "si está marcado, el sistema enviará automáticamente un correo claro al operador y tripulación 5 minutos después de que la tripulación o piloto actualice una o más disponibilidades",
      "calendarClosing": "Texto de cierre",
      "calendarClosingHint": "este texto de cierre se añadirá al correo",
      "flightCrew": "Enviar un correo cuando añada un piloto o miembro de tripulación a un vuelo",
      "flightCrewHint": "si está marcado, se enviará automáticamente un correo al piloto y tripulación cuando los añada o elimine de un vuelo",
      "save": "guardar"
    },
    "booking": {
      "title": "reservas",
      "childAge": "edad de niño",
      "disabledPaymentTypes": "tipos de pago desactivados",
      "disabledPaymentTypesHint": "si desactiva un tipo de pago, no se mostrará en el proceso de reserva.",
      "none_of_the_paymentTypes_are_disabled": "ninguno de los tipos de pago está desactivado",
      "disabledPaymentTypesSave": "guardar tipos de pago desactivados",
      "childAgeHint": "cada pasajero con esta edad o menor será marcado como niño",
      "sources": "orígenes",
      "flightOptionsCount": "número de opciones de vuelo",
      "flightOptionsCountHint": "el número de próximos vuelos en globo adecuados para la reserva, teniendo en cuenta el número de pasajeros y cualquier restricción (etiquetas)."
    },
    "flight": {
      "title": "vuelos",
      "sunriseOffset": "desfase de amanecer",
      "sunriseOffsetHint": "la hora del vuelo se calcula basándose en el amanecer menos el número de minutos de desfase, redondeado a la media hora.",
      "sunsetOffset": "desfase de atardecer",
      "sunsetOffsetHint": "la hora del vuelo se calcula basándose en el atardecer menos el número de minutos de desfase, redondeado a la media hora.",
      "meetingTimeOffset": "desfase de hora de encuentro",
      "meetingTimeOffsetHint": "la hora de encuentro para el vuelo se calcula basándose en la hora del vuelo menos el número de minutos de desfase. Si es 0, la hora de encuentro no se muestra.",
      "sunrise": "amanecer",
      "sunset": "atardecer",
      "hourMeeting": "hora de encuentro",
      "hour": "hora de despegue",
      "save": "guardar desfases",
      "save_hint": "Los nuevos desfases solo aplican a vuelos creados a partir de ahora",
      "save_and_update_hours": "guardar desfases (y actualizar horas de vuelos)",
      "save_and_update_hours_hint": "todos los próximos vuelos se actualizarán con los nuevos desfases",
      "cancelReason": "motivo de cancelación",
      "cancelReasons": "motivos de cancelación",
      "cancelReasonsHint": "si se cancela un vuelo, puede indicar el motivo de cancelación",
      "cancelReasons_list_empty": "no se encontraron motivos de cancelación, añada su primer motivo de cancelación",
      "new_cancelreason": "nuevo motivo de cancelación",
      "you_can_manage_all_cancelreasons_in_settings": "puede gestionar todos los motivos de cancelación en configuración",
      "cancelreason_validation": "el motivo de cancelación es requerido, mín 3, máx 50 caracteres y debe ser único",
      "defaultPeriod": "período predeterminado",
      "defaultPeriodHint": "elija el período predeterminado para crear nuevos vuelos entre vuelos matutinos o vespertinos",
      "morning": "mañana",
      "evening": "tarde",
      "duplicateProtection": "protección de vuelos duplicados",
      "duplicateProtectionHint": "Previene que un globo sea programado para múltiples vuelos simultáneamente. No puede añadir pasajeros a un vuelo si el mismo globo ya tiene otro vuelo activo en ese momento.",
      "duplicateProtection_enabled": "protección activada",
      "duplicateProtection_disabled": "protección desactivada"
    },
    "myflight": {
      "title": "Quick Release UP (App de Pasajeros)",
      "autoConfirm": "confirmar automáticamente el vuelo cuando se solicita a través de UP",
      "autoConfirmHint": "si no está marcado, el operador tiene que confirmar el vuelo manualmente, cuando se añade a través de UP",
      "autoConfirmEmailTemplate": "plantilla de correo de confirmación",
      "autoConfirmEmailTemplateHint": "seleccione una plantilla de correo para enviar automáticamente al pasajero cuando se confirme la reserva",
      "noEmailTemplate": "sin correo automático",
      "autoConfirmAPI": "confirmar automáticamente el vuelo cuando se solicita a través de API",
      "autoConfirmAPIHint": "si no está marcado, el operador tiene que confirmar el vuelo manualmente, cuando se añade a través de API (sitio web)",
      "endOfSeason": "fin de temporada",
      "endOfSeasonHint": "si está marcado, los pasajeros ya no pueden acceder a su reserva a través de UP",
      "flights": "¿Qué vuelos pueden reservarse a través de UP?",
      "ALL": "todos los vuelos, teniendo en cuenta las restricciones de etiquetas",
      "REGIONAL": "solo vuelos regionales (vuelos en la misma región que la reserva)",
      "NONE": "sin vuelos (los pasajeros solo pueden ver su reserva)",
      "parameters": "parámetros",
      "branding": "marca",
      "logo": "logo",
      "logoHint": "suba su propio logo aquí para mostrarlo en la app UP",
      "drag_and_drop_file_here": "arrastre y suelte archivo jpg o png aquí (máx 500kB)",
      "colors": "colores",
      "colorsHint": "haga clic en cada color para ajustarlos a su propia marca. Puede elegir un color de la paleta de su logo en el popup",
      "example": "ejemplo",
      "reset": "restablecer colores",
      "save": "guardar colores y logo",
      "primary_background_color": "color de fondo de la app",
      "secondary_background_color": "color de fondo de los mosaicos",
      "primary_foreground_color": "color del título y botones",
      "secondary_foreground_color": "color del texto informativo",
      "invalid_file_type_or_size": "tipo o tamaño de archivo inválido",
      "attachment_not_found": "Archivo adjunto no encontrado — elimine y vuelva a subir",
      "translations": "Traducciones",
      "change_translations": "Algunos textos pueden personalizarse",
      "click_button_to_change_translations": "Abra la pantalla de inicio de sesión de la app UP para pasajeros con el botón de abajo. Inicie sesión con una reserva de prueba o una de sus reservas existentes. En cualquier lugar donde vea el siguiente icono, puede ajustar la traducción.",
      "goto_api_settings": "Necesita una clave API para poder cambiar las traducciones. Vaya a configuración de API para generar una clave API.",
      "update_translations": "Actualizar traducciones"
    },
    "cao": {
      "title": "CAO"
    },
    "sms": {
      "footerEnabled": "añadir pie de página a SMS",
      "footerEnabledHint": "si no está marcado, el pie de página no se añadirá a todos los SMS de invitación"
    },
    "api": {
      "external_connection": "conexiones externas",
      "external_connection_subtitle": "conecte su sitio web u otras apps con Quick Release",
      "apiKey": "Clave API",
      "generateApiKey": "Generar Clave API",
      "noKeyMessage": "Aún no tiene una Clave API. Genere una Clave API para acceder a la API.",
      "documentation": "Documentación",
      "documentationDescription": "Lea la documentación para más información sobre la API.",
      "apiPlayground": "Playground de API",
      "FlightAppDocumentation": "Documentación de FlightApp",
      "FlightAppHint": "Conecte Quick Release con los cuadernos de bitácora digitales reconocidos de FlightApp. Los vuelos completados se reenvían automáticamente a FlightApp. Quick Release verifica la validez de globos y pilotos con FlightApp.",
      "FlightAppApikeyNotValid": "Error: esta clave API de FlightApp no es válida",
      "FlightAppAircraftNotValid": "Error: este globo de FlightApp no se encontró en el sistema. Por favor verifique el indicativo.",
      "FlightAppPilotNotValid": "Error: este piloto de FlightApp no se encontró en el sistema. Por favor verifique la dirección de correo.",
      "addFlightAppApiKey": "Añadir Clave API de FlightApp",
      "hideApiKey": "Ocultar Clave API",
      "showApiKey": "Mostrar Clave API",
      "copyToClipboard": "Copiar al portapapeles",
      "newApiKey": "Nueva Clave API",
      "newApiKeyHint": "Introduzca la nueva Clave API",
      "updating_keys": "las claves API se están actualizando"
    },
    "callback": {
      "title": "URL de Callback",
      "subtitle": "Establezca una URL de callback para recibir notificaciones sobre eventos de reserva. El payload JSON contiene el bookingId, flightId y el nuevo estado de la reserva",
      "url": "URL de Callback",
      "noUrlMessage": "No se ha establecido URL de callback. Haga clic en el botón de abajo para establecer una.",
      "setUrl": "Establecer URL de Callback",
      "saveUrl": "Guardar URL",
      "clearUrl": "Borrar URL"
    },
    "security": {
      "title": "Seguridad",
      "twoFA": "Autenticación de dos factores",
      "description": "La autenticación de dos factores añade una capa extra de seguridad a su cuenta. En dispositivos no confiables, necesitará introducir un código adicional de 6 dígitos que recibirá por correo electrónico.",
      "enableTwoFA": "Activar autenticación de dos factores",
      "enableTwoFAConfirm": "Activar la autenticación de dos factores cerrará su sesión inmediatamente. ¿Está seguro?",
      "mandatory": "La autenticación de dos factores es obligatoria a partir del 1 de enero de 2026"
    },
    "checkin_title": "Check-in en línea",
    "checkin_mode_none": "sin check-in",
    "checkin_mode_none_hint": "No se utiliza el check-in.",
    "checkin_mode_pdf": "check-in PDF (manual)",
    "checkin_mode_pdf_hint": "Imprima la hoja de check-in con sus instrucciones; los pasajeros firman en papel el día del vuelo.",
    "checkin_mode_online": "check-in PDF + en línea",
    "checkin_mode_online_hint": "Los pasajeros hacen el check-in en línea antes del vuelo a través de la aplicación de reservas; la hoja PDF sigue disponible. Se requiere un canal de notificación (correo o WhatsApp).",
    "checkin_days_before": "Días antes del vuelo",
    "checkin_notification_channel": "Canal de notificación de check-in",
    "checkin_instructions": "Instrucciones de check-in (Markdown)",
    "checkin_save_instructions": "guardar instrucciones de check-in",
    "checkin_load_default": "Cargar instrucciones predeterminadas",
    "checkin_preview": "Vista previa",
    "checkin_schedule_explanation": "Cuando el check-in está habilitado, los pasajeros pueden registrarse en línea {{days}} días antes de su vuelo a través de la aplicación de reservas. Cada día a las 10:00 (hora belga) se envía automáticamente una notificación a las reservas confirmadas cuya ventana de check-in esté abierta.",
    "checkin_passenger_explanation": "Este texto se muestra durante el check-in en línea (el pasajero debe confirmar que lo ha leído y comprendido) y se imprime en la hoja de check-in PDF encima de las firmas. Tras el check-in en línea, la reserva pasa a ser de solo lectura en la aplicación.",
    "checkin_channel_title": "Canal de notificación",
    "checkin_inapp_title": "texto de check-in",
    "checkin_email_preview_title": "Notificación por correo electrónico",
    "checkin_email_preview_subject": "Asunto",
    "checkin_whatsapp_preview_title": "Notificación WhatsApp",
    "checkin_email_template_hint": "Esta plantilla se puede personalizar en Configuración → Plantillas de correo electrónico",
    "checkin_sms_template_hint": "Esta plantilla se puede personalizar en Configuración → Plantillas SMS/WhatsApp. El enlace de reserva se envía automáticamente como un mensaje separado."
  },
  "REPORTS": {
    "flights": "vuelos",
    "bookings_open": "reservas abiertas",
    "bookings": "nuevas reservas",
    "vouchers": "bonos",
    "payments": "pagos",
    "sms": "MSG"
  },
  "MAIL": {
    "hide": "ocultar detalles",
    "show": "mostrar detalles",
    "sent": "enviado",
    "error": "envío fallido"
  },
  "TENANT_ACTIONS": {
    "WHATSAPP_PAIR_REQUIRED": "Es necesario reconectar WhatsApp. Tus mensajes no se enviarán hasta que escanees el nuevo código QR.",
    "WHATSAPP_SESSION_DISCONNECTED": "Tu WhatsApp está desconectado. Reconecta para seguir enviando mensajes.",
    "cta": "Reconectar ahora",
    "dismiss": "Cerrar notificación"
  },
  "SUBSCRIPTION": {
    "WA_CLOUD": {
            "billable": "WhatsApp Business paid (Meta)",
            "free": "WhatsApp Business free",
            "info": "Indicative — Meta bills WhatsApp Business messages directly on your own Meta account."
        },
    "sms_available": "disponible en suscripción",
    "sms_sent": "SMS enviados",
    "wa_sent": "WhatsApp enviados",
    "recalculate": "recalcular",
    "pct_sms_used": "% de sus SMS usados",
    "sms_info": "Contáctenos para pedir SMS adicionales cuando haya usado el 95% de los SMS disponibles en su suscripción",
    "sms_warning": "Ha usado el 95% o más de sus SMS disponibles.",
    "order_sms": "Pedir nuevos SMS ahora",
    "sms_ignore_warning": "Ocultar notificación sobre uso de SMS",
    "pct_plan_used": "% de sus plazas usadas",
    "plan_seats_used": "capacidad total de globos",
    "plan_valid_until": "válido hasta",
    "plan_info": "Contáctenos para cambiar a un plan superior si el número de plazas es muy bajo o para renovar su suscripción actual",
    "plan_expiring": "Su suscripción expirará pronto. Por favor renueve para evitar interrupciones.",
    "plan_expiring_days": "Su suscripción expira en {days} días. Por favor renueve para evitar interrupciones.",
    "plan_expired_grace_days": "Su suscripción ha expirado. El período de gracia termina en {days} días. Por favor renueve inmediatamente.",
    "plan_expired_since_days": "Su suscripción expiró hace {days} días. Por favor renueve para continuar usando Quick Release.",
    "plan_expired": "Su suscripción ha expirado y el período de gracia ha terminado. Por favor renueve para continuar usando Quick Release.",
    "plan_invalid_grace_days": "Su suscripción no es válida - ha excedido su capacidad. El período de gracia termina en {days} días. Por favor renueve inmediatamente.",
    "plan_invalid_expired": "Su suscripción no es válida - ha excedido su capacidad. El período de gracia ha terminado. Por favor renueve inmediatamente para continuar usando Quick Release.",
    "manage_subscription": "Gestionar suscripción",
    "EXPIRED_MESSAGE": "Suscripción expirada. Renueve para continuar.",
    "blocked": "Suscripción expirada. Por favor renueve para continuar.",
    "custom_plan_title": "Plan de Suscripción Personalizado",
    "custom_plan_subtitle": "Renovación manual requerida",
    "custom_plan_message": "Tiene un plan de suscripción personalizado.",
    "custom_plan_contact": "Por favor contacte al equipo de Quick Release para solicitar un ajuste o renovación."
  },
  "TAGS": {
    "delete": "eliminar etiqueta",
    "enabled": "activado",
    "enable_tag": "activar etiqueta",
    "disabled": "desactivado",
    "disable_tag": "desactivar etiqueta",
    "save": "guardar etiqueta",
    "new_tag": "crear nueva etiqueta",
    "tag_name": "nombre de etiqueta",
    "tag_type": "tipo de etiqueta",
    "select_tag_color": "seleccionar color",
    "color": "color",
    "tag_already_added": "etiqueta ya añadida",
    "edit": "editar etiqueta",
    "flight_tags": "etiquetas de vuelo",
    "tags": "etiquetas",
    "show_on_dashboard": "mostrar en el panel",
    "allowedFlightTags": "permitidas",
    "not_restricted": "todas las reservas permitidas",
    "all_flights_allowed": "todos los vuelos permitidos, excepto cuando se requieren etiquetas de reserva específicas",
    "onlyAllowedFlightTags": "solo las siguientes etiquetas de reserva están permitidas",
    "no_bookings_allowed": "ninguna reserva permitida"
  },
  "LOGBOOK": {
    "no_logbook_found": "no se encontró cuaderno de bitácora",
    "new_logs_since": "Nuevos registros desde",
    "new_logs_since_beginning": "Nuevos registros desde el inicio",
    "total_new_logs": "Número de nuevos registros:",
    "total_flight_time": "Tiempo total de vuelo:",
    "add": "Añadir",
    "log": "registro",
    "logs": "registros",
    "refresh": "Actualizar",
    "logs_in_logbook": "Registros en cuaderno de bitácora",
    "total_logs": "Número de registros:",
    "latest_log": "Último registro:",
    "export": "Exportar",
    "send_to_flightapp": "Enviar a FlightApp",
    "delete_log": "Eliminar registro",
    "confirm_delete_log": "¿Eliminar este registro?",
    "confirm_delete_log_body": "Esto elimina el registro del cuaderno de bitácora. Esta acción no se puede deshacer.",
    "start_date": "Fecha de inicio",
    "initial_hours": "Horas de vuelo previas al cuaderno digital",
    "initial_hours_hint": "Horas del cuaderno en papel",
    "total_logged_time": "Tiempo de vuelo registrado",
    "total_overall_time": "Tiempo de vuelo total",
    "settings": "Ajustes del cuaderno",
    "setup_logbook": "Configurar cuaderno",
    "start_date_hint": "Inicio del cuaderno digital. Los vuelos anteriores a esta fecha pertenecen al cuaderno en papel — introduce sus totales abajo; los vuelos desde esta fecha se cuentan desde Quick Release. Los vuelos digitales más antiguos siguen visibles, en gris.",
    "before_start_date": "Antes de la fecha de inicio — era en papel, no contada en los totales",
    "hours": "horas",
    "minutes": "Minutos",
    "save_settings": "Guardar",
    "settings_saved": "Ajustes del cuaderno guardados",
    "initial_flights": "Vuelos antes del cuaderno",
    "initial_flights_short": "previos",
    "total_flights": "Vuelos totales",
    "flights": "vuelos",
    "logged_short": "registrados",
    "stats_since": "Estadísticas desde",
    "logbook_title": "Cuaderno de bitácora",
    "up_to_date": "Al día",
    "pending_short": "por añadir",
    "from_system_pending": "del sistema, aún no añadidos",
    "logged_flights": "Vuelos registrados"
  },
  "IMAGES": {
    "images": "imágenes",
    "manage_images_for": "Gestionar imágenes para",
    "upload_new_images": "Subir nuevas imágenes",
    "drag_and_drop_images_here": "Arrastre y suelte imágenes aquí",
    "max_files_reached": "Número máximo de imágenes alcanzado",
    "browse_for_images": "Buscar imágenes",
    "supported_formats": "Formatos soportados",
    "max_size_5mb": "tamaño máximo 5MB",
    "uploading": "Subiendo",
    "image_library": "Biblioteca de imágenes",
    "no_images_found": "No se encontraron imágenes",
    "delete_image": "Eliminar imagen",
    "hint": "Las imágenes que suba pueden usarse al enviar mensajes de WhatsApp"
  },
  "INVOICE": {
    "LOADING": "Cargando facturas...",
    "EMPTY_STATE": "No se encontraron facturas de los últimos 4 años",
    "TABLE": {
      "TITLE": "Facturas",
      "SUBTITLE": "Resumen de sus facturas",
      "INFO": "Aquí puede encontrar todas sus facturas de los últimos 4 años. Haga clic en el icono de descarga para descargar una factura.",
      "INVOICE_CODE": "Código de Factura",
      "AMOUNT": "Importe",
      "DATE": "Fecha",
      "STATUS": "Estado",
      "ACTIONS": "Acciones",
      "DOWNLOAD_TOOLTIP": "Descargar Factura"
    },
    "STATUS": {
      "PAID": "Pagada",
      "SENT": "Enviada",
      "REMINDED": "Recordada",
      "SUMMATION": "Citación",
      "EXPIRED": "Vencida",
      "DRAFT": "Borrador"
    }
  },
  "ORDER": {
    "LOADING": "Cargando pedidos...",
    "EMPTY_STATE": "No se encontraron pedidos de los últimos 4 años",
    "TABLE": {
      "TITLE": "Pedidos",
      "SUBTITLE": "Resumen de sus pedidos",
      "INFO_PENDING": "Puede añadir artículos a un pedido pendiente o eliminarlo completamente.",
      "INFO_CONFIRMED_TITLE": "Después de la confirmación:",
      "INFO_CONFIRMED_1": "Recibirá una confirmación de pedido por correo electrónico",
      "INFO_CONFIRMED_2": "Su pedido será procesado y aprobado",
      "INFO_CONFIRMED_3": "Recibirá la factura por correo electrónico",
      "INFO_CONFIRMED_4": "El nuevo plan o créditos se activarán",
      "AMOUNT": "Importe",
      "DATE": "Fecha",
      "STATUS": "Estado",
      "ITEMS": "Artículos",
      "PLAN": "Plan"
    },
    "STATUS": {
      "PENDING": "Pendiente",
      "CONFIRMED": "Procesando",
      "APPROVED": "Aprobado",
      "CANCELLED": "Cancelado"
    },
    "ACTIONS": {
      "CONFIRM": "Confirmar",
      "DELETE": "Eliminar",
      "APPROVE": "Aprobar",
      "CANCEL": "Cancelar"
    }
  },
  "DEBTOR_VALIDATION": {
    "TITLE": "Configuración de Facturación Requerida",
    "SUBTITLE": "Sus datos de deudor necesitan ser configurados",
    "MESSAGE": "Para habilitar la renovación automática y la funcionalidad de actualización, por favor contacte al equipo de Quick Release para configurar sus datos de facturación."
  },
  "NEW_ORDER": {
    "TITLE": "Nuevo Pedido",
    "SUBTITLE": "Añadir artículos a su pedido",
    "INFO_SMS": "Pedir crédito adicional: 1 o más paquetes de 100 SMS o 1000 SMS.",
    "INFO_PLAN": "Calculado automáticamente basándose en el estado de su suscripción y capacidad de globos. Para actualizaciones, solo paga la diferencia.",
    "SUBTITLE_PLAN": "Calculado automáticamente basándose en el estado de su suscripción y capacidad de globos. Para actualizaciones, solo paga la diferencia.",
    "SUBTITLE_SMS": "Pedir crédito adicional: 1 o más paquetes de 100 SMS o 1000 SMS.",
    "PLAN": {
      "TITLE": "Renovación/Actualización de Plan",
      "EMPTY_MESSAGE": "No hay planes disponibles",
      "NAME": "Plan",
      "MAX_SEATS": "Plazas máximas"
    },
    "UNIT_PRICE": "Precio unitario",
    "QUANTITY": "Cantidad",
    "ORDER_QUANTITY": "Cantidad",
    "TOTAL": "Total",
    "CREDIT_AUTO_ADDED": "Crédito aplicado automáticamente",
    "ALREADY_IN_ORDER": "Ya en el pedido",
    "ADD_TO_ORDER": "Añadir al Pedido",
    "SMS": {
      "TITLE": "SMS",
      "UNIT_PRICE": "Precio por paquete",
      "PER_PACKAGE": "Por paquete",
      "ORDER_QUANTITY": "Número de paquetes",
      "TOTAL_SMS": "Total SMS"
    },
    "SUCCESS": "Artículo añadido al pedido",
    "ERROR_LINE": "Error al añadir línea de pedido",
    "ERROR_ORDER": "Error al crear pedido",
    "SUBMITTING": "Realizando pedidos...",
    "ORDER_PROCESSING": "Un pedido está siendo procesado actualmente. No puede añadir nuevos pedidos hasta que sea aprobado o cancelado.",
    "CONFIRM_DIALOG": {
      "TITLE": "Confirmar Pedido",
      "MESSAGE": "Está a punto de realizar un pedido.",
      "ORDER": "Pedido",
      "TOTAL": "Total",
      "VAT_EXCL": "IVA excl.",
      "VAT_21": "IVA 21%",
      "TOTAL_WITH_VAT": "Total con IVA",
      "VAT_REVERSE_CHARGE_NOTE": "Nota: La inversión del sujeto pasivo (transferencia de IVA) puede aplicarse a su pedido.",
      "VAT_REVERSE_CHARGE_SHORT": "(puede aplicarse inversión del sujeto pasivo)",
      "NO_PAYMENT_OBLIGATION": "Una vez aprobado su pedido, recibirá una factura con obligación de pago.",
      "AGREE_TERMS": "Acepto los",
      "TERMS_LINK": "términos y condiciones generales",
      "CONFIRM_ORDER": "Confirmar Pedido"
    }
  },
  "CHECKIN": {
    "not_all_checked_in": "No todos los pasajeros han realizado el check-in en línea",
    "proceed_warning": "{{count}} de {{total}} reservas confirmadas no han completado el check-in en línea. ¿Desea continuar?",
    "opens_on": "Check-in abre el {{date}}",
    "checked_in": "registrado",
    "checkin_open": "Check-in abierto",
    "invite_sent_at": "invitación de check-in enviada el {{date}}",
    "invite_not_sent": "aún no se ha enviado invitación de check-in",
    "send_invite": "enviar invitación de check-in",
    "invite_sent_success": "invitación de check-in enviada",
    "send_invite_all": "enviar invitación de check-in a todas las reservas abiertas",
    "send_invite_all_confirm": "¿Enviar invitación de check-in a {{count}} reservas?",
    "invites_status_sent": "{{count}} invitación(es) enviada(s)",
    "invites_status_planned": "{{count}} planificada(s) para el {{date}}",
    "invite_planned_on": "invitación de check-in planificada para el {{date}}",
    "send_now": "enviar ahora",
    "preview_subject": "Su vuelo está listo para el check-in – {{date}} – {{location}}",
    "preview_greeting": "Estimado/a {{name}},",
    "preview_body": "Su vuelo en globo del <strong>{{date}}</strong> ya está abierto para el check-in en línea.",
    "preview_body2": "Complete el check-in de su grupo ({{count}} pasajeros) antes de la fecha del vuelo. Durante el check-in se le pedirá revisar y confirmar las instrucciones de seguridad.",
    "preview_cta": "Registrarse ahora",
    "preview_footer": "Si tiene alguna pregunta, no dude en contactarnos.",
    "preview_wa_body": "Su vuelo en globo del **{{date}}** ya está abierto para el check-in en línea.",
    "preview_wa_body2": "Complete el check-in de su grupo ({{count}} pasajeros) antes de la fecha del vuelo.",
    "preview_wa_link": "¡Accede directamente a tu página de reserva personal a través de este enlace!",
    "signature_sheet": "hoja de firmas del check-in",
    "acknowledge": "He leído y comprendido la información anterior",
    "pdf_check_in": "CHECK-IN",
    "pdf_passenger_manifest": "Lista de pasajeros",
    "pdf_safety_briefing": "Briefing de seguridad",
    "pdf_please_read": "Leer antes de embarcar",
    "pdf_balloon_operator": "Operador de globo aerostático",
    "pdf_acknowledgement": "CONFIRMACIÓN",
    "pdf_passenger": "Pasajero",
    "pdf_signature": "Firma",
    "pdf_morning_flight": "Vuelo de la mañana",
    "pdf_evening_flight": "Vuelo de la tarde",
    "pdf_date": "FECHA",
    "pdf_balloon": "GLOBO",
    "pdf_pic": "PILOTO AL MANDO",
    "pdf_takeoff": "DESPEGUE",
    "pdf_pic_on_file": "Firma del piloto registrada",
    "pdf_local_time": "Hora local",
    "pdf_page": "Página {{current}} de {{total}}",
    "pdf_manifest_subtitle": "{{pax}} pasajeros · {{bookings}} reservas"
  },
  "NOTAM": {
    "title": "NOTAM",
    "panel_title_combined": "meteo y NOTAM",
    "tooltip_count": "{{count}} NOTAM — abrir el vuelo para más detalles",
    "none_known": "no se conocen NOTAM relevantes",
    "none_known_short": "sin NOTAM conocidos",
    "no_data": "sin datos NOTAM para esta ubicación",
    "stale": "no se pudieron actualizar los datos NOTAM — última actualización {{time}}",
    "unavailable": "datos NOTAM no disponibles",
    "retry": "reintentar",
    "updated": "datos NOTAM actualizados {{time}}",
    "disclaimer": "Solo apoyo a la decisión — la obligación oficial de briefing previo al vuelo sigue siendo del piloto al mando (PIC).",
    "horizon_hint": "los NOTAM se publican normalmente poco antes de la fecha, vuelve a comprobarlo cerca del vuelo",
    "wide_area": "avisos de fondo (área extensa / AIP)",
    "show_text": "mostrar texto NOTAM original",
    "hide_text": "ocultar texto NOTAM original",
    "period": "período activo",
    "schedule": "horario diario",
    "altitude_band": "banda de altitud",
    "connect_hint": "conecta tu cuenta de Autorouter para ver avisos NOTAM",
    "reconnect_hint": "vuelve a conectar tu cuenta de Autorouter para actualizar los avisos NOTAM",
    "connect_link": "abrir ajustes",
    "location_warning": "{{count}} NOTAM en esta ubicación para la ventana del vuelo",
    "CATEGORY": {
      "RESTRICTION": "restricción del espacio aéreo",
      "WARNING": "aviso a la navegación",
      "OBSTACLE": "obstáculo",
      "AERODROME": "aeródromo",
      "UNCLASSIFIED": "sin clasificar"
    },
    "SETTINGS": {
      "title": "Espacio aéreo / NOTAM",
      "explanation": "Los avisos NOTAM en vuelos, el mapa de trayectoria y el panel requieren una cuenta propia (gratuita) de autorouter.aero. Quick Release obtiene los datos NOTAM con la autorización de tu cuenta.",
      "disclaimer": "Los avisos NOTAM son solo apoyo a la decisión; la obligación oficial de briefing previo al vuelo sigue siendo del piloto al mando (PIC).",
      "connect": "conectar cuenta de Autorouter",
      "reconnect": "reconectar cuenta de Autorouter",
      "disconnect": "desconectar",
      "disconnect_confirm": "¿Desconectar tu cuenta de Autorouter? Se eliminarán la autorización guardada y los datos NOTAM obtenidos.",
      "connected_as": "conectado como",
      "connected_since": "desde",
      "status_disconnected": "ninguna cuenta de Autorouter conectada",
      "reauth_warning": "la autorización de Autorouter caducó o fue revocada — reconecta para seguir recibiendo datos NOTAM",
      "connected_snack": "cuenta de Autorouter conectada",
      "denied_snack": "conexión de Autorouter rechazada",
      "error_snack": "fallo al conectar con Autorouter — inténtalo de nuevo"
    }
  },
  "WEEKPLANNER": {
    "matrix": {
      "availability": "disponibilidad",
      "availability_tooltip": "Número de pilotos y tripulación disponibles — pasa el ratón por los puntos para ver los nombres",
      "availability_empty": "Aún no hay gestión de disponibilidad. Deja que pilotos y tripulación indiquen su disponibilidad y verás aquí quién puede volar cada día.",
      "start_crew_login": "Empezar con el acceso de tripulación",
      "pilots_available": "pilotos disponibles",
      "crew_available": "tripulación disponible",
      "open_balloon": "Abrir el detalle del globo",
      "seats": "plazas",
      "add_balloon": "Añadir globo",
      "no_balloons": "Aún no hay globos. Añade tu primer globo para planificar vuelos.",
      "no_flights": "No hay vuelos esta semana.",
      "show_idle_balloons": "Globos sin vuelo ({{count}})",
      "hide_idle_balloons": "Ocultar globos sin vuelo",
      "add_flight_for": "Añadir vuelo —",
      "open_flight_tooltip": "Abrir el detalle del vuelo (o Ctrl/Cmd-clic en la celda)",
      "fly_ok": "Volable",
      "fly_wind": "Aviso de viento",
      "fly_rain": "No volable — precipitación",
      "fly_nogo_wind": "No volable — viento"
    },
    "availability": {
      "yes": "disponible",
      "maybe": "quizás",
      "no": "no disponible",
      "unknown": "sin indicar"
    },
    "create": {
      "new_location_option": "+ Nueva ubicación…",
      "no_locations": "Aún no tienes lugares de despegue. Crea el primero.",
      "new_location": "Nueva ubicación",
      "new_location_placeholder": "p. ej. Brujas – Minnewater",
      "new_location_note": "GPS, permiso y contacto se completan más tarde en el detalle de la ubicación.",
      "save_location": "Guardar ubicación",
      "location_created": "Ubicación {{name}} creada.",
      "location_created_default": "Ubicación {{name}} creada — también tu ubicación predeterminada para el tiempo y el sol."
    },
    "planner": {
      "available_drag": "disponible — arrastra a un vuelo",
      "no_people": "aún no hay pilotos ni tripulación",
      "assign_to": "Asignar a…",
      "add_pilot": "Piloto",
      "add_crew": "Tripulación",
      "edit": "Editar la información del vuelo",
      "edit_done": "Edición terminada",
      "publish": "Publicar para la tripulación",
      "unpublish": "Ocultar a la tripulación",
      "mark_finished": "Marcar como realizado",
      "cancel": "Cancelar vuelo",
      "restore": "Restaurar vuelo",
      "staffing": "Piloto, conductor BE y tripulación",
      "published_chip": "tripulación",
      "published_tooltip": "Visible para la tripulación",
      "pilot": "Piloto",
      "driver": "Conductor BE",
      "crew": "Tripulación",
      "takeoff_temperature": "Temperatura al despegar",
      "trajectory": "trayectoria",
      "lift_free": "{{kg}} kg libres",
      "capacity_warning_title": "Esto supera la capacidad del globo",
      "capacity_warning_body": "{{total}} pasajeros para {{capacity}} plazas. ¿Continuar de todos modos?",
      "lift_warning_title": "Poca sustentación en este vuelo",
      "lift_warning_body": "Solo quedan {{lift}} kg de sustentación. ¿Asignar de todos modos?",
      "person_already_assigned": "{{name}} ya está en {{flight}} en esta franja.",
      "cancel_on_flight_page": "Este vuelo tiene reservas confirmadas: cancélalo en la página del vuelo para avisar a los pasajeros.",
      "preferred_of": "tripulación habitual de {{balloons}}",
      "propose_crew": "Proponer tripulación habitual",
      "propose_tooltip": "Poner a {{names}} en el vuelo de {{balloon}}",
      "apply_all": "Aplicar todo"
    },
    "toast": {
      "flight_updated": "Vuelo actualizado — datos de la semana recargados.",
      "booking_confirmed": "Reserva confirmada — correo de confirmación enviado.",
      "balloon_updated": "Globo actualizado.",
      "save_failed": "Error al guardar — inténtalo de nuevo."
    },
    "pool": {
      "oldest_first": "más antiguas primero",
      "clear_search": "borrar",
      "new_booking": "Nueva reserva",
      "filters": "filtros",
      "count_tooltip": "número dentro de la búsqueda actual",
      "chip_to_confirm": "por confirmar",
      "chip_unplanned": "sin planificar",
      "chip_voucher": "bono a punto de caducar",
      "chip_open_amount": "importe pendiente",
      "chip_favourite": "favorito",
      "clear_filters": "borrar filtros",
      "col_name": "Nombre",
      "col_contact": "Contacto",
      "col_pax": "Pers. · peso",
      "col_info": "Info",
      "col_comment": "Comentario",
      "col_flight": "Vuelo",
      "col_actions": "Acciones",
      "no_match": "No hay reservas para estos filtros.",
      "flight_tooltip": "Abrir el vuelo — arrastrar mueve la reserva",
      "unplanned": "sin planificar",
      "confirm": "Confirmar",
      "load_more_n": "Cargar más ({{n}})"
    },
    "panel": {
      "kind_flight": "Vuelo",
      "kind_balloon": "Globo",
      "kind_booking": "Reserva",
      "kind_person": "Persona",
      "kind_location": "Ubicación",
      "back": "Volver al planificador semanal",
      "close": "Cerrar",
      "not_found": "No encontrado — quizá se eliminó.",
      "balloon": "Globo",
      "status": "Estado",
      "status_SCH": "planificado",
      "status_REA": "listo para salir",
      "status_FIN": "realizado",
      "status_CAN": "cancelado",
      "sun": "Sol",
      "sunrise": "salida del sol",
      "sunset": "puesta del sol",
      "yes": "sí",
      "no": "no",
      "crew_section": "Tripulación",
      "bookings": "Reservas",
      "no_bookings_on_flight": "Aún no hay reservas en este vuelo.",
      "heading": "Dirección prevista",
      "distance": "Distancia",
      "landing_zone": "Zona de aterrizaje",
      "logbook": "Cuaderno de vuelo",
      "takeoff_time": "Hora de despegue",
      "landing_time": "Hora de aterrizaje",
      "landing_place": "Lugar de aterrizaje",
      "fuel": "Consumo (botellas)",
      "open_page": "Abrir página completa",
      "passenger_seats": "plazas de pasajeros",
      "passenger_seats_label": "Plazas de pasajeros",
      "basics": "Datos básicos",
      "registration": "Matrícula",
      "to_complete": "por completar",
      "envelope": "Envoltura",
      "envelope_manufacturer": "Fabricante",
      "envelope_volume": "Volumen (m³)",
      "envelope_type": "Tipo",
      "basket_burner": "Cesta y quemador",
      "basket_type": "Tipo de cesta",
      "burner_type": "Quemador",
      "cylinders": "Número de botellas",
      "insurance": "Seguro",
      "insurance_company": "Compañía",
      "due_date": "Vencimiento",
      "maintenance": "Mantenimiento",
      "last_inspection": "Última inspección",
      "envelope_hours": "Horas de vuelo envoltura",
      "flights_this_week": "Vuelos esta semana",
      "no_flights": "No hay vuelos planificados.",
      "booking_detail": "Detalle de la reserva",
      "contact": "Contacto",
      "phone": "Teléfono",
      "email": "Correo",
      "city": "Localidad",
      "passengers": "Pasajeros",
      "preferred": "Preferido",
      "not_chosen": "aún sin elegir",
      "not_planned": "Sin planificar.",
      "booking_status_OPEN": "abierta",
      "booking_status_ADDE": "añadida — por confirmar",
      "booking_status_INVI": "invitada",
      "booking_status_CONF": "confirmada",
      "booking_status_COMP": "completada",
      "booking_status_CANC": "cancelada",
      "region": "Región",
      "payment": "Pago",
      "to_pay": "A pagar",
      "paid": "Pagado",
      "voucher": "Bono regalo",
      "booking_code": "Código",
      "valid_until": "Válido hasta",
      "passenger_n": "Pasajero {{n}}",
      "open_flight": "Abrir vuelo",
      "availability_this_week": "Disponibilidad esta semana",
      "profile": "Perfil",
      "license_number": "Número de licencia",
      "license_expiry": "Licencia válida hasta",
      "medical_until": "Certificado médico hasta",
      "driver_licence_be": "Carné BE",
      "launch_site": "Lugar de despegue",
      "default_for_weather": "ubicación predeterminada para el tiempo y el sol",
      "default_location": "Ubicación predeterminada",
      "no_flights_location": "No hay vuelos desde esta ubicación.",
      "location_detail": "Detalle de la ubicación",
      "gps": "Coordenadas GPS",
      "address": "Dirección",
      "contact_person": "Persona de contacto",
      "access_parking": "Acceso y aparcamiento",
      "preferred_crew": "Tripulación habitual",
      "preferred_crew_note": "Basado en asignaciones anteriores.",
      "preferred_crew_of": "Tripulación habitual de",
      "no_preferred_balloon": "Aún sin globo habitual — se deduce de las asignaciones."
    },
    "meteo": {
      "title": "Meteo",
      "no_default_location": "sin ubicación predeterminada",
      "follows_selection": "sigue el día seleccionado",
      "today_hint": "hoy — selecciona un día en la matriz",
      "sun": "sol {{rise}} – {{set}}",
      "pill_good": "volable",
      "pill_marginal": "dudoso",
      "pill_nogo": "no volable",
      "pill_unknown": "sin previsión",
      "pill_tooltip_good": "Volable — viento dentro de los límites",
      "pill_tooltip_marginal": "Dudoso — rachas por encima del límite",
      "pill_tooltip_nogo": "No volable — precipitación o viento fuera de límites",
      "pill_tooltip_unknown": "Sin previsión para esta franja",
      "no_forecast": "sin previsión para este día",
      "row_hour": "Hora",
      "row_weather": "Tiempo",
      "row_temp": "Temp (°C)",
      "row_ground": "Suelo",
      "row_wind": "Viento (kn)",
      "row_gust": "Rachas (kn)",
      "row_pressure": "Presión (hPa)",
      "row_clouds": "Nubosidad",
      "row_visibility": "Visibilidad (km)",
      "legend": "horas doradas — ventanas de vuelo alrededor de la salida ({{rise}}) y la puesta del sol ({{set}}) · barbas: entera = 10 kn, media = 5 kn",
      "updated": "actualizado"
    },
    "myWeek": {
      "title": "Mi semana — {{name}}",
      "hint": "disponibilidad: haz clic para cambiar · arrastra a otros días para copiar",
      "my_availability": "mi disponibilidad",
      "flights": "Vuelos",
      "click_to_fill": "haz clic para indicar",
      "own_pilot": "Mi vuelo — piloto yo",
      "own_crew": "Mi vuelo — voy de tripulación",
      "published": "Vuelo publicado",
      "join": "Me apunto",
      "saved": "Disponibilidad guardada — el planificador la ve enseguida.",
      "cleared": "Disponibilidad borrada.",
      "error_FLIGHT_HAS_CREW": "Otra persona ya se ha apuntado a este vuelo.",
      "error_FLIGHT_NOT_PUBLISHED": "Este vuelo ya no está publicado.",
      "error_FLIGHT_NOT_SCHEDULED": "Este vuelo ya no está planificado.",
      "error_NOT_ON_FLIGHT": "Ya no estás en este vuelo.",
      "error_ALREADY_PILOT": "Ya eres el piloto de este vuelo."
    },
    "theme": {
      "title": "Tema",
      "light": "Claro",
      "dark": "Oscuro",
      "system": "Sistema"
    }
  }
}
